/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  TimeStamp: { input: any; output: any; }
};

export type Account = {
  __typename?: 'Account';
  accept_marketing?: Maybe<Scalars['Boolean']['output']>;
  active?: Maybe<Scalars['Boolean']['output']>;
  activity_logs?: Maybe<Array<Maybe<ActivityLog>>>;
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  alpineiq_contact_id?: Maybe<Scalars['String']['output']>;
  alpineiq_verified?: Maybe<Scalars['Boolean']['output']>;
  checkin_from_dispensary?: Maybe<Scalars['Boolean']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  city_code?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['TimeStamp']['output']>;
  date_of_birth?: Maybe<Scalars['TimeStamp']['output']>;
  driver_license_id?: Maybe<Scalars['String']['output']>;
  driver_license_id_expiration_date?: Maybe<Scalars['TimeStamp']['output']>;
  driver_license_photo?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  entity_id?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<GenderType>;
  has_account?: Maybe<Scalars['Boolean']['output']>;
  jane_orders_imported?: Maybe<Scalars['Boolean']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  leaf_logic_id?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  loyalty_points?: Maybe<Scalars['Float']['output']>;
  loyalty_points_time_line?: Maybe<Array<Maybe<LoyaltyPointsTimeLine>>>;
  medical_id?: Maybe<AccountMedicalId>;
  notes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  phone?: Maybe<Scalars['String']['output']>;
  photo?: Maybe<Scalars['String']['output']>;
  province?: Maybe<Scalars['String']['output']>;
  province_code?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Scalars['String']['output']>;
  total_order_expense?: Maybe<Scalars['Int']['output']>;
  treez_customer_info?: Maybe<Array<Maybe<TreezCustomerInfo>>>;
  treez_ids?: Maybe<Array<Maybe<AccountTreezId>>>;
  type?: Maybe<AccountType>;
  updated_at?: Maybe<Scalars['TimeStamp']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type AccountCursorPagination = {
  __typename?: 'AccountCursorPagination';
  accounts?: Maybe<Array<Maybe<Account>>>;
  cursor?: Maybe<Scalars['String']['output']>;
};

export type AccountFilter = {
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
};

export type AccountMedicalId = {
  __typename?: 'AccountMedicalID';
  expiration_date: Scalars['TimeStamp']['output'];
  number: Scalars['String']['output'];
};

export type AccountMedicalIdInput = {
  expiration_date: Scalars['TimeStamp']['input'];
  number: Scalars['String']['input'];
};

export type AccountPassword = {
  __typename?: 'AccountPassword';
  confirmation_code?: Maybe<Scalars['String']['output']>;
  password?: Maybe<Scalars['String']['output']>;
};

export enum AccountPhotoType {
  Id = 'ID',
  Selfie = 'SELFIE'
}

export type AccountSetting = {
  __typename?: 'AccountSetting';
  active?: Maybe<Scalars['Boolean']['output']>;
  auto_verify_email?: Maybe<Scalars['Boolean']['output']>;
  cognito_identity_pool_id?: Maybe<Scalars['String']['output']>;
  cognito_region?: Maybe<Scalars['String']['output']>;
  user_pools_id?: Maybe<Scalars['String']['output']>;
  user_pools_web_client_id?: Maybe<Scalars['String']['output']>;
};

export type AccountSettingInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  auto_verify_email?: InputMaybe<Scalars['Boolean']['input']>;
  cognito_identity_pool_id?: InputMaybe<Scalars['String']['input']>;
  cognito_region?: InputMaybe<Scalars['String']['input']>;
  user_pools_id?: InputMaybe<Scalars['String']['input']>;
  user_pools_web_client_id?: InputMaybe<Scalars['String']['input']>;
};

export type AccountTreezId = {
  __typename?: 'AccountTreezID';
  id: Scalars['String']['output'];
  store_id: Scalars['String']['output'];
};

export type AccountTreezIdInput = {
  id: Scalars['String']['input'];
  store_id: Scalars['String']['input'];
};

export enum AccountType {
  Adult = 'ADULT',
  Medical = 'MEDICAL'
}

export type AccountUploadPhotoInput = {
  file_name: Scalars['String']['input'];
  file_type: Scalars['String']['input'];
};

export type ActivityLog = {
  __typename?: 'ActivityLog';
  action?: Maybe<Scalars['String']['output']>;
  status: OrderStatusType;
  timestamp?: Maybe<Scalars['TimeStamp']['output']>;
  user?: Maybe<Scalars['String']['output']>;
};

export type AddAccountNotesInput = {
  id: Scalars['String']['input'];
  notes: Array<Scalars['String']['input']>;
};

export type AddAeroPayPaymentDetailInput = {
  order_id: Scalars['String']['input'];
  transaction_id: Scalars['String']['input'];
};

export type AeroPayPaymentDetail = {
  __typename?: 'AeroPayPaymentDetail';
  amount: Scalars['Int']['output'];
  customer_name: Scalars['String']['output'];
  merchant_name: Scalars['String']['output'];
  transaction_id: Scalars['String']['output'];
  uuid?: Maybe<Scalars['String']['output']>;
};

export type AeroPayPaymentDetailInput = {
  amount: Scalars['Int']['input'];
  customer_name: Scalars['String']['input'];
  merchant_name: Scalars['String']['input'];
  transaction_id: Scalars['String']['input'];
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type Aeropay = App & {
  __typename?: 'Aeropay';
  category: AppCategoryType;
  created_at?: Maybe<Scalars['TimeStamp']['output']>;
  credentials?: Maybe<Array<AeropayCredentials>>;
  handler: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  status?: Maybe<Scalars['Boolean']['output']>;
  type: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['TimeStamp']['output']>;
};

export type AeropayCredentials = {
  __typename?: 'AeropayCredentials';
  api_key?: Maybe<Scalars['String']['output']>;
  api_secret?: Maybe<Scalars['String']['output']>;
  host?: Maybe<Scalars['String']['output']>;
  location_uuid?: Maybe<Scalars['String']['output']>;
  merchant_id?: Maybe<Scalars['String']['output']>;
  sandbox?: Maybe<Scalars['Boolean']['output']>;
  store_provider_id?: Maybe<Scalars['String']['output']>;
};

export type AeropayCredentialsInput = {
  api_key: Scalars['String']['input'];
  api_secret: Scalars['String']['input'];
  host: Scalars['String']['input'];
  location_uuid: Scalars['String']['input'];
  merchant_id: Scalars['String']['input'];
  sandbox?: InputMaybe<Scalars['Boolean']['input']>;
  store_provider_id: Scalars['String']['input'];
};

export type AeropayInput = {
  category: AppCategoryType;
  created_at?: InputMaybe<Scalars['TimeStamp']['input']>;
  credentials?: InputMaybe<Array<AeropayCredentialsInput>>;
  handler: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  status?: InputMaybe<Scalars['Boolean']['input']>;
  type: Scalars['String']['input'];
  updated_at?: InputMaybe<Scalars['TimeStamp']['input']>;
};

export type AlpineIq = App & Crm & {
  __typename?: 'AlpineIQ';
  api_key?: Maybe<Scalars['String']['output']>;
  campaign_id?: Maybe<Scalars['String']['output']>;
  category: AppCategoryType;
  created_at?: Maybe<Scalars['TimeStamp']['output']>;
  favorites_stores: Array<AlpineStore>;
  handler: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  notify_by_sms?: Maybe<Scalars['Boolean']['output']>;
  order_canceled_sms_message?: Maybe<Scalars['String']['output']>;
  order_canceled_sms_message_active?: Maybe<Scalars['Boolean']['output']>;
  order_completed_sms_message?: Maybe<Scalars['String']['output']>;
  order_completed_sms_message_active?: Maybe<Scalars['Boolean']['output']>;
  order_confirm_sms_message?: Maybe<Scalars['String']['output']>;
  order_confirm_sms_message_active?: Maybe<Scalars['Boolean']['output']>;
  order_ready_sms_message?: Maybe<Scalars['String']['output']>;
  order_ready_sms_message_active?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
  type: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['TimeStamp']['output']>;
  used_for_rewards?: Maybe<Scalars['Boolean']['output']>;
  used_for_subscription?: Maybe<Scalars['Boolean']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

export type AlpineIqInput = {
  api_key?: InputMaybe<Scalars['String']['input']>;
  campaign_id?: InputMaybe<Scalars['String']['input']>;
  category: AppCategoryType;
  created_at?: InputMaybe<Scalars['TimeStamp']['input']>;
  favorites_stores: Array<AlpineStoreInput>;
  handler: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  notify_by_sms?: InputMaybe<Scalars['Boolean']['input']>;
  order_canceled_sms_message?: InputMaybe<Scalars['String']['input']>;
  order_canceled_sms_message_active?: InputMaybe<Scalars['Boolean']['input']>;
  order_completed_sms_message?: InputMaybe<Scalars['String']['input']>;
  order_completed_sms_message_active?: InputMaybe<Scalars['Boolean']['input']>;
  order_confirm_sms_message?: InputMaybe<Scalars['String']['input']>;
  order_confirm_sms_message_active?: InputMaybe<Scalars['Boolean']['input']>;
  order_ready_sms_message?: InputMaybe<Scalars['String']['input']>;
  order_ready_sms_message_active?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  type: Scalars['String']['input'];
  updated_at?: InputMaybe<Scalars['TimeStamp']['input']>;
  used_for_rewards?: InputMaybe<Scalars['Boolean']['input']>;
  used_for_subscription?: InputMaybe<Scalars['Boolean']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

export type AlpineStore = {
  __typename?: 'AlpineStore';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type AlpineStoreInput = {
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

export type App = {
  category: AppCategoryType;
  created_at?: Maybe<Scalars['TimeStamp']['output']>;
  handler: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  status?: Maybe<Scalars['Boolean']['output']>;
  type: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['TimeStamp']['output']>;
};

export enum AppCategoryType {
  Accounting = 'ACCOUNTING',
  Ads = 'ADS',
  Crm = 'CRM',
  Delivery = 'DELIVERY',
  Ecommerce = 'ECOMMERCE',
  Erp = 'ERP',
  Idcheck = 'IDCHECK',
  Metafield = 'METAFIELD',
  None = 'NONE',
  Payment = 'PAYMENT',
  Redirect = 'REDIRECT',
  ReverseProxy = 'REVERSE_PROXY'
}

export enum ApplyType {
  EachItem = 'EACH_ITEM',
  Order = 'ORDER'
}

export type Asset = {
  __typename?: 'Asset';
  image?: Maybe<Scalars['String']['output']>;
  image_extra_large_size?: Maybe<Scalars['String']['output']>;
  image_large_size?: Maybe<Scalars['String']['output']>;
  image_medium_size?: Maybe<Scalars['String']['output']>;
  stock?: Maybe<Scalars['Boolean']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
};

export type AssetInput = {
  image?: InputMaybe<Scalars['String']['input']>;
  image_extra_large_size?: InputMaybe<Scalars['String']['input']>;
  image_large_size?: InputMaybe<Scalars['String']['input']>;
  image_medium_size?: InputMaybe<Scalars['String']['input']>;
  stock?: InputMaybe<Scalars['Boolean']['input']>;
  thumbnail?: InputMaybe<Scalars['String']['input']>;
};

export type AwsPinpointAnalytics = {
  __typename?: 'AwsPinpointAnalytics';
  active?: Maybe<Scalars['Boolean']['output']>;
  app_id?: Maybe<Scalars['String']['output']>;
  auth_region?: Maybe<Scalars['String']['output']>;
  identity_pool_id?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
};

export type AwsPinpointAnalyticsInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  app_id?: InputMaybe<Scalars['String']['input']>;
  auth_region?: InputMaybe<Scalars['String']['input']>;
  identity_pool_id?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
};

export type Berbix = App & {
  __typename?: 'Berbix';
  category: AppCategoryType;
  created_at?: Maybe<Scalars['TimeStamp']['output']>;
  handler: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  secret_key: Scalars['String']['output'];
  status?: Maybe<Scalars['Boolean']['output']>;
  template: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['TimeStamp']['output']>;
};

export type BerbixClientToken = {
  __typename?: 'BerbixClientToken';
  access_token: Scalars['String']['output'];
  client_token: Scalars['String']['output'];
  expires_at: Scalars['String']['output'];
  refresh_token: Scalars['String']['output'];
};

export type BerbixClientTokenInput = {
  user_id: Scalars['String']['input'];
};

export type BerbixInput = {
  category: AppCategoryType;
  created_at?: InputMaybe<Scalars['TimeStamp']['input']>;
  handler: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  secret_key: Scalars['String']['input'];
  status?: InputMaybe<Scalars['Boolean']['input']>;
  template: Scalars['String']['input'];
  type: Scalars['String']['input'];
  updated_at?: InputMaybe<Scalars['TimeStamp']['input']>;
};

export type BerbixTransactionResult = {
  __typename?: 'BerbixTransactionResult';
  id: Scalars['String']['output'];
  reason_not_validated?: Maybe<Scalars['String']['output']>;
  valitated_user: Scalars['Boolean']['output'];
};

export type BestSellingProduct = {
  __typename?: 'BestSellingProduct';
  category?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  qty?: Maybe<Scalars['Int']['output']>;
  sales_price?: Maybe<Scalars['Int']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
  unit_price?: Maybe<Scalars['Int']['output']>;
};

export type Blaze = App & {
  __typename?: 'Blaze';
  auth_key?: Maybe<Scalars['String']['output']>;
  category: AppCategoryType;
  created_at?: Maybe<Scalars['TimeStamp']['output']>;
  dev_auth_key?: Maybe<Scalars['String']['output']>;
  dev_partner_key?: Maybe<Scalars['String']['output']>;
  handler: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  partner_key?: Maybe<Scalars['String']['output']>;
  sandbox?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
  type: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['TimeStamp']['output']>;
};

export type BlazeInput = {
  auth_key?: InputMaybe<Scalars['String']['input']>;
  category: AppCategoryType;
  created_at?: InputMaybe<Scalars['TimeStamp']['input']>;
  dev_auth_key?: InputMaybe<Scalars['String']['input']>;
  dev_partner_key?: InputMaybe<Scalars['String']['input']>;
  handler: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  partner_key?: InputMaybe<Scalars['String']['input']>;
  sandbox?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  type: Scalars['String']['input'];
  updated_at?: InputMaybe<Scalars['TimeStamp']['input']>;
};

export type BlazeProductInventory = {
  __typename?: 'BlazeProductInventory';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type BlazeTerminalInventory = {
  __typename?: 'BlazeTerminalInventory';
  brand?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  qty?: Maybe<Scalars['Int']['output']>;
  strain?: Maybe<Scalars['String']['output']>;
  thc?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type Brand = {
  __typename?: 'Brand';
  asset?: Maybe<Asset>;
  created_at?: Maybe<Scalars['TimeStamp']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  feature?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['TimeStamp']['output']>;
  vendors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  website?: Maybe<Scalars['String']['output']>;
};

export type BrandInput = {
  asset?: InputMaybe<AssetInput>;
  created_at?: InputMaybe<Scalars['TimeStamp']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  feature?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['TimeStamp']['input']>;
  vendors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export enum BroadcastType {
  EmailPopup = 'EMAIL_POPUP',
  HeaderBarAllPage = 'HEADER_BAR_ALL_PAGE',
  HeaderBarHomePage = 'HEADER_BAR_HOME_PAGE'
}

export type BusinessAccount = {
  __typename?: 'BusinessAccount';
  address?: Maybe<BusinessAccountAddress>;
  company?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['TimeStamp']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  signed?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
  updated_at?: Maybe<Scalars['TimeStamp']['output']>;
};

export type BusinessAccountAddress = {
  __typename?: 'BusinessAccountAddress';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  province?: Maybe<Scalars['String']['output']>;
  province_code?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type BusinessAccountInput = {
  address?: InputMaybe<BusinessAddressInput>;
  company?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['TimeStamp']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  signed?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['TimeStamp']['input']>;
};

export type BusinessAddressInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  country_code?: InputMaybe<Scalars['String']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
  province_code?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type Crm = {
  used_for_subscription?: Maybe<Scalars['Boolean']['output']>;
};

export enum CannabisType {
  Cbd = 'CBD',
  CbdCannabis = 'CBD_CANNABIS',
  CbdCannabisFlower = 'CBD_CANNABIS_FLOWER',
  CloneCutting = 'CLONE_CUTTING',
  CloneTissueCulture = 'CLONE_TISSUE_CULTURE',
  Concentrate = 'CONCENTRATE',
  Default = 'DEFAULT',
  DryFlower = 'DRY_FLOWER',
  DryLeaf = 'DRY_LEAF',
  Edible = 'EDIBLE',
  Extract = 'EXTRACT',
  ImmaturePlant = 'IMMATURE_PLANT',
  Kief = 'KIEF',
  Liquid = 'LIQUID',
  LivePlant = 'LIVE_PLANT',
  None = 'NONE',
  NonCannabis = 'NON_CANNABIS',
  NonConcentrate = 'NON_CONCENTRATE',
  Oil = 'OIL',
  Plant = 'PLANT',
  PreRoll = 'PRE_ROLL',
  PreRollCbd = 'PRE_ROLL_CBD',
  PreRollFlower = 'PRE_ROLL_FLOWER',
  PreRollInfused = 'PRE_ROLL_INFUSED',
  PreRollLeaf = 'PRE_ROLL_LEAF',
  Seeds = 'SEEDS',
  SeedsEa = 'SEEDS_EA',
  Suppository = 'SUPPOSITORY',
  Thc = 'THC',
  Tincture = 'TINCTURE',
  Topical = 'TOPICAL'
}

export type Category = {
  __typename?: 'Category';
  asset?: Maybe<Asset>;
  cannabis_type?: Maybe<CannabisType>;
  created_at?: Maybe<Scalars['TimeStamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  feature?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  is_cannabis?: Maybe<Scalars['Boolean']['output']>;
  low_threshold?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parent_id?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
  short_description?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  unit_type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['TimeStamp']['output']>;
  wm_category?: Maybe<Scalars['String']['output']>;
};

export type CategoryInput = {
  asset?: InputMaybe<AssetInput>;
  cannabis_type?: InputMaybe<CannabisType>;
  created_at?: InputMaybe<Scalars['TimeStamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  feature?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  is_cannabis?: InputMaybe<Scalars['Boolean']['input']>;
  low_threshold?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  short_description?: InputMaybe<Scalars['String']['input']>;
  unit_type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['TimeStamp']['input']>;
  wm_category?: InputMaybe<Scalars['String']['input']>;
};

export type ClientDetail = {
  __typename?: 'ClientDetail';
  device?: Maybe<Scalars['String']['output']>;
  user_agent?: Maybe<Scalars['String']['output']>;
  x_forwarded_for?: Maybe<Scalars['String']['output']>;
};

export type Closure = {
  __typename?: 'Closure';
  all_day?: Maybe<Scalars['Boolean']['output']>;
  end_date: Scalars['String']['output'];
  name: Scalars['String']['output'];
  note: Scalars['String']['output'];
  reservation_mode: ReservationMode;
  start_date: Scalars['String']['output'];
  stores_provider_ids?: Maybe<Array<Scalars['String']['output']>>;
  time_end?: Maybe<Scalars['String']['output']>;
  time_start?: Maybe<Scalars['String']['output']>;
};

export type ClosureInput = {
  all_day?: InputMaybe<Scalars['Boolean']['input']>;
  end_date: Scalars['String']['input'];
  name: Scalars['String']['input'];
  note: Scalars['String']['input'];
  reservation_mode: ReservationMode;
  start_date: Scalars['String']['input'];
  stores_provider_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  time_end?: InputMaybe<Scalars['String']['input']>;
  time_start?: InputMaybe<Scalars['String']['input']>;
};

export type Component = {
  __typename?: 'Component';
  amount?: Maybe<Scalars['Int']['output']>;
  percentage?: Maybe<Scalars['Int']['output']>;
};

export type ComponentInput = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  percentage?: InputMaybe<Scalars['Int']['input']>;
};

export type ContactInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ContactWallet = {
  __typename?: 'ContactWallet';
  contact_id?: Maybe<Scalars['String']['output']>;
  discount_templates?: Maybe<Array<DiscountTemplate>>;
  hide_points_in_wallet?: Maybe<Scalars['Boolean']['output']>;
  leaky_bucket?: Maybe<Scalars['String']['output']>;
  loyalty?: Maybe<Scalars['Boolean']['output']>;
  loyalty_points?: Maybe<Scalars['Float']['output']>;
  repeat_customer?: Maybe<Scalars['Boolean']['output']>;
  top20?: Maybe<Scalars['Boolean']['output']>;
};

export type Coordinates = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

export type Cova = App & {
  __typename?: 'Cova';
  category: AppCategoryType;
  client_id?: Maybe<Scalars['String']['output']>;
  client_secret?: Maybe<Scalars['String']['output']>;
  company_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['TimeStamp']['output']>;
  handler: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  password?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
  type: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['TimeStamp']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type CovaInput = {
  category: AppCategoryType;
  client_id: Scalars['String']['input'];
  client_secret: Scalars['String']['input'];
  company_id: Scalars['String']['input'];
  created_at?: InputMaybe<Scalars['TimeStamp']['input']>;
  handler: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  password: Scalars['String']['input'];
  status?: InputMaybe<Scalars['Boolean']['input']>;
  type: Scalars['String']['input'];
  updated_at?: InputMaybe<Scalars['TimeStamp']['input']>;
  username: Scalars['String']['input'];
};

export type CreateAccountInput = {
  accept_marketing?: InputMaybe<Scalars['Boolean']['input']>;
  date_of_birth?: InputMaybe<Scalars['TimeStamp']['input']>;
  email: Scalars['String']['input'];
  first_name: Scalars['String']['input'];
  last_name: Scalars['String']['input'];
  medical_id?: InputMaybe<AccountMedicalIdInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<AccountType>;
};

export type CreateStrongholdPayLinkInput = {
  exit_callback?: InputMaybe<Scalars['String']['input']>;
  order_id: Scalars['String']['input'];
  success_callback?: InputMaybe<Scalars['String']['input']>;
  type: StrongholdPayType;
};

export type CreateStrongholdPayLinkResponse = {
  __typename?: 'CreateStrongholdPayLinkResponse';
  url?: Maybe<Scalars['String']['output']>;
};

export type CreateSwifterSessionInput = {
  email: Scalars['String']['input'];
  firstname?: InputMaybe<Scalars['String']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
  order_id: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerOrderFilter = {
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
};

export enum CustomerType {
  Adult = 'ADULT',
  All = 'ALL',
  Medical = 'MEDICAL'
}

export type Delivery = {
  __typename?: 'Delivery';
  active?: Maybe<Scalars['Boolean']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
};

export type DeliveryAddress = {
  __typename?: 'DeliveryAddress';
  apartment?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type DeliveryEta = {
  __typename?: 'DeliveryETA';
  steps?: Maybe<Array<Maybe<DeliveryEtaWorkerStep>>>;
  vehicle_type?: Maybe<DeliveryVehicleType>;
  worker_image?: Maybe<Scalars['String']['output']>;
  worker_name?: Maybe<Scalars['String']['output']>;
};

export type DeliveryEtaWorkerStep = {
  __typename?: 'DeliveryETAWorkerStep';
  arrival_time?: Maybe<Scalars['TimeStamp']['output']>;
  completion_time?: Maybe<Scalars['TimeStamp']['output']>;
  distance?: Maybe<Scalars['Int']['output']>;
  location?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
};

export type DeliveryHub = {
  __typename?: 'DeliveryHub';
  address?: Maybe<DeliveryAddress>;
  id?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  name?: Maybe<Scalars['String']['output']>;
};

export type DeliveryInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
};

export enum DeliveryStatus {
  Arriving = 'ARRIVING',
  Completed = 'COMPLETED',
  Delayed = 'DELAYED',
  Failed = 'FAILED',
  Started = 'STARTED',
  Submited = 'SUBMITED'
}

export type DeliveryVehicle = {
  __typename?: 'DeliveryVehicle';
  color?: Maybe<Scalars['String']['output']>;
  type?: Maybe<DeliveryVehicleType>;
};

export enum DeliveryVehicleType {
  Bicycle = 'BICYCLE',
  Car = 'CAR',
  Motorcycle = 'MOTORCYCLE',
  Truck = 'TRUCK'
}

export type DeliveryWorker = {
  __typename?: 'DeliveryWorker';
  id?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  is_responding?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  name?: Maybe<Scalars['String']['output']>;
  on_duty?: Maybe<Scalars['Boolean']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type DeploymentStatus = {
  __typename?: 'DeploymentStatus';
  last_updated_since: Scalars['TimeStamp']['output'];
  status: Scalars['String']['output'];
};

export type Dimension = {
  __typename?: 'Dimension';
  height?: Maybe<Scalars['Float']['output']>;
  height_unit?: Maybe<DimensionUnitType>;
  length?: Maybe<Scalars['Float']['output']>;
  length_unit?: Maybe<DimensionUnitType>;
  weight?: Maybe<Scalars['Float']['output']>;
  weight_unit?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
  width_unit?: Maybe<DimensionUnitType>;
};

export type DimensionInput = {
  height?: InputMaybe<Scalars['Float']['input']>;
  height_unit?: InputMaybe<DimensionUnitType>;
  length?: InputMaybe<Scalars['Float']['input']>;
  length_unit?: InputMaybe<DimensionUnitType>;
  weight?: InputMaybe<Scalars['Float']['input']>;
  weight_unit?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
  width_unit?: InputMaybe<DimensionUnitType>;
};

export enum DimensionUnitType {
  Cm = 'CM',
  Ft = 'FT',
  In = 'IN',
  M = 'M',
  Mm = 'MM'
}

export enum DiscountApplyType {
  Automatically = 'AUTOMATICALLY',
  PromotionCode = 'PROMOTION_CODE'
}

export enum DiscountRateType {
  Amount = 'AMOUNT',
  Percentage = 'PERCENTAGE'
}

export type DiscountTemplate = {
  __typename?: 'DiscountTemplate';
  available?: Maybe<Scalars['Boolean']['output']>;
  avatar?: Maybe<Scalars['String']['output']>;
  disable_stacking?: Maybe<Scalars['Boolean']['output']>;
  dollar_value?: Maybe<Scalars['Int']['output']>;
  ecom_coupon?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  in_store_redemption?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  page_title?: Maybe<Scalars['String']['output']>;
  percentage_value?: Maybe<Scalars['Int']['output']>;
  point_deduction?: Maybe<Scalars['Int']['output']>;
  pos_discount_id?: Maybe<Scalars['String']['output']>;
  price_max?: Maybe<Scalars['Int']['output']>;
  price_min?: Maybe<Scalars['Int']['output']>;
  redemption_url?: Maybe<Scalars['String']['output']>;
  reusable?: Maybe<Scalars['Boolean']['output']>;
  reusable_cooldown?: Maybe<Scalars['Int']['output']>;
  reusable_cooldown_unit?: Maybe<Scalars['Int']['output']>;
  tier_discount?: Maybe<Scalars['Boolean']['output']>;
};

export enum DiscountType {
  AmountOffOrder = 'AMOUNT_OFF_ORDER',
  FreeDeliveryDiscount = 'FREE_DELIVERY_DISCOUNT',
  ProductDiscount = 'PRODUCT_DISCOUNT',
  Rewards = 'REWARDS'
}

export type Distance = {
  __typename?: 'Distance';
  dimension: DistanceDimensionUnitType;
  value: Scalars['Float']['output'];
};

export enum DistanceDimensionUnitType {
  Km = 'KM',
  Mi = 'MI'
}

export type DriverInventory = {
  __typename?: 'DriverInventory';
  brand?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  qty?: Maybe<Scalars['Int']['output']>;
  strain?: Maybe<Scalars['String']['output']>;
  thc?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type Dutchie = App & {
  __typename?: 'Dutchie';
  category: AppCategoryType;
  created_at?: Maybe<Scalars['TimeStamp']['output']>;
  credentials: Array<DutchieCreds>;
  handler: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  status?: Maybe<Scalars['Boolean']['output']>;
  type: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['TimeStamp']['output']>;
};

export type DutchieCreds = {
  __typename?: 'DutchieCreds';
  api_key: Scalars['String']['output'];
  retailer_id: Scalars['String']['output'];
  secret_api_key: Scalars['String']['output'];
  store_name: Scalars['String']['output'];
};

export type DutchieCredsInput = {
  api_key: Scalars['String']['input'];
  retailer_id: Scalars['String']['input'];
  secret_api_key: Scalars['String']['input'];
  store_name: Scalars['String']['input'];
};

export type DutchieInput = {
  category: AppCategoryType;
  created_at?: InputMaybe<Scalars['TimeStamp']['input']>;
  credentials: Array<DutchieCredsInput>;
  handler: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  status?: InputMaybe<Scalars['Boolean']['input']>;
  type: Scalars['String']['input'];
  updated_at?: InputMaybe<Scalars['TimeStamp']['input']>;
};

export type ErrorResponse = {
  __typename?: 'ErrorResponse';
  code: ErrorResponseCodeType;
  message: Scalars['String']['output'];
};

export enum ErrorResponseCodeType {
  CanNotUpdatePaidTicket = 'CAN_NOT_UPDATE_PAID_TICKET',
  CustomerNotFound = 'CUSTOMER_NOT_FOUND',
  InactiveCustomer = 'INACTIVE_CUSTOMER',
  InsufficientRewardsPoints = 'INSUFFICIENT_REWARDS_POINTS',
  InsufficientSellableQuantity = 'INSUFFICIENT_SELLABLE_QUANTITY',
  InvalidCoupon = 'INVALID_COUPON',
  InvalidRequest = 'INVALID_REQUEST',
  InvalidToken = 'INVALID_TOKEN',
  LocationNameDoesNotMatch = 'LOCATION_NAME_DOES_NOT_MATCH',
  PartialPaymentNotSupported = 'PARTIAL_PAYMENT_NOT_SUPPORTED',
  ResponseLimitExceeded = 'RESPONSE_LIMIT_EXCEEDED',
  Unknown = 'UNKNOWN',
  ValidationError = 'VALIDATION_ERROR'
}

export type ExpressMenuConfig = {
  __typename?: 'ExpressMenuConfig';
  active?: Maybe<Scalars['Boolean']['output']>;
  active_by_default?: Maybe<Scalars['Boolean']['output']>;
  end?: Maybe<Scalars['String']['output']>;
  inventory_provider_ids?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['String']['output']>;
};

export type ExpressMenuConfigInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  active_by_default?: InputMaybe<Scalars['Boolean']['input']>;
  end?: InputMaybe<Scalars['String']['input']>;
  inventory_provider_ids?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['String']['input']>;
};

export type FacebookCatalog = App & {
  __typename?: 'FacebookCatalog';
  category: AppCategoryType;
  created_at?: Maybe<Scalars['TimeStamp']['output']>;
  facebook_catalog_url?: Maybe<Scalars['String']['output']>;
  handler: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  status?: Maybe<Scalars['Boolean']['output']>;
  type: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['TimeStamp']['output']>;
};

export type FacebookCatalogInput = {
  category: AppCategoryType;
  created_at?: InputMaybe<Scalars['TimeStamp']['input']>;
  facebook_catalog_url?: InputMaybe<Scalars['String']['input']>;
  handler: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  status?: InputMaybe<Scalars['Boolean']['input']>;
  type: Scalars['String']['input'];
  updated_at?: InputMaybe<Scalars['TimeStamp']['input']>;
};

export type FeatureFlag = {
  __typename?: 'FeatureFlag';
  allow_cancel_order_from_confirmation_page?: Maybe<Scalars['Boolean']['output']>;
  allow_curbside_pickup?: Maybe<Scalars['Boolean']['output']>;
  allow_discount_loyalty_stacking?: Maybe<Scalars['Boolean']['output']>;
  allow_guest_checkout?: Maybe<Scalars['Boolean']['output']>;
  allow_id_verification_for_delivery?: Maybe<Scalars['Boolean']['output']>;
  allow_id_verification_for_pickup?: Maybe<Scalars['Boolean']['output']>;
  allow_medical_sign_ups?: Maybe<Scalars['Boolean']['output']>;
  bypass_barcode_validation?: Maybe<Scalars['Boolean']['output']>;
  checkout_countdown_time?: Maybe<Scalars['Int']['output']>;
  curbside_pickup_placeholder?: Maybe<Scalars['String']['output']>;
  disable_product_reviews?: Maybe<Scalars['Boolean']['output']>;
  discount_minimum_threshold_value?: Maybe<Scalars['Int']['output']>;
  display_low_in_stock_products?: Maybe<Scalars['Boolean']['output']>;
  display_out_of_stock_products?: Maybe<Scalars['Boolean']['output']>;
  force_to_select_store?: Maybe<Scalars['Boolean']['output']>;
  id_verification_description?: Maybe<Scalars['String']['output']>;
  id_verification_title?: Maybe<Scalars['String']['output']>;
  is_add_to_cart_in_kiosk_disabled?: Maybe<Scalars['Boolean']['output']>;
  is_grlimit_active?: Maybe<Scalars['Boolean']['output']>;
  is_med_and_rec_selection_active?: Maybe<Scalars['Boolean']['output']>;
  keep_shopping_active?: Maybe<Scalars['Boolean']['output']>;
  kiosk_countdown_time?: Maybe<Scalars['Int']['output']>;
  kiosk_dob_required?: Maybe<Scalars['Boolean']['output']>;
  kiosk_email_required?: Maybe<Scalars['Boolean']['output']>;
  kiosk_first_name_required?: Maybe<Scalars['Boolean']['output']>;
  kiosk_last_name_required?: Maybe<Scalars['Boolean']['output']>;
  kiosk_phone_required?: Maybe<Scalars['Boolean']['output']>;
  kiosk_thank_you_timeout_seconds?: Maybe<Scalars['Int']['output']>;
  kiosk_timeout_seconds?: Maybe<Scalars['Int']['output']>;
  require_state_at_checkout?: Maybe<Scalars['Boolean']['output']>;
  sb_540_regulation?: Maybe<Scalars['Boolean']['output']>;
  show_product_warning?: Maybe<Scalars['Boolean']['output']>;
  show_striketrough_price?: Maybe<Scalars['Boolean']['output']>;
  treez_filter_sort?: Maybe<Scalars['String']['output']>;
  treez_filters_title_mapping?: Maybe<Scalars['String']['output']>;
  wishlist_active?: Maybe<Scalars['Boolean']['output']>;
  enable_mmid_tooltip?: Maybe<Scalars['Boolean']['output']>;
};

export type FeatureFlagInput = {
  allow_cancel_order_from_confirmation_page?: InputMaybe<Scalars['Boolean']['input']>;
  allow_curbside_pickup?: InputMaybe<Scalars['Boolean']['input']>;
  allow_discount_loyalty_stacking?: InputMaybe<Scalars['Boolean']['input']>;
  allow_guest_checkout?: InputMaybe<Scalars['Boolean']['input']>;
  allow_id_verification_for_delivery?: InputMaybe<Scalars['Boolean']['input']>;
  allow_id_verification_for_pickup?: InputMaybe<Scalars['Boolean']['input']>;
  allow_medical_sign_ups?: InputMaybe<Scalars['Boolean']['input']>;
  bypass_barcode_validation?: InputMaybe<Scalars['Boolean']['input']>;
  checkout_countdown_time?: InputMaybe<Scalars['Int']['input']>;
  curbside_pickup_placeholder?: InputMaybe<Scalars['String']['input']>;
  disable_product_reviews?: InputMaybe<Scalars['Boolean']['input']>;
  discount_minimum_threshold_value?: InputMaybe<Scalars['Int']['input']>;
  display_low_in_stock_products?: InputMaybe<Scalars['Boolean']['input']>;
  display_out_of_stock_products?: InputMaybe<Scalars['Boolean']['input']>;
  force_to_select_store?: InputMaybe<Scalars['Boolean']['input']>;
  id_verification_description?: InputMaybe<Scalars['String']['input']>;
  id_verification_title?: InputMaybe<Scalars['String']['input']>;
  is_add_to_cart_in_kiosk_disabled?: InputMaybe<Scalars['Boolean']['input']>;
  is_grlimit_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_med_and_rec_selection_active?: InputMaybe<Scalars['Boolean']['input']>;
  keep_shopping_active?: InputMaybe<Scalars['Boolean']['input']>;
  kiosk_countdown_time?: InputMaybe<Scalars['Int']['input']>;
  kiosk_dob_required?: InputMaybe<Scalars['Boolean']['input']>;
  kiosk_email_required?: InputMaybe<Scalars['Boolean']['input']>;
  kiosk_first_name_required?: InputMaybe<Scalars['Boolean']['input']>;
  kiosk_last_name_required?: InputMaybe<Scalars['Boolean']['input']>;
  kiosk_phone_required?: InputMaybe<Scalars['Boolean']['input']>;
  kiosk_thank_you_timeout_seconds?: InputMaybe<Scalars['Int']['input']>;
  kiosk_timeout_seconds?: InputMaybe<Scalars['Int']['input']>;
  require_state_at_checkout?: InputMaybe<Scalars['Boolean']['input']>;
  sb_540_regulation?: InputMaybe<Scalars['Boolean']['input']>;
  show_product_warning?: InputMaybe<Scalars['Boolean']['input']>;
  show_striketrough_price?: InputMaybe<Scalars['Boolean']['input']>;
  treez_filter_sort?: InputMaybe<Scalars['String']['input']>;
  treez_filters_title_mapping?: InputMaybe<Scalars['String']['input']>;
  wishlist_active?: InputMaybe<Scalars['Boolean']['input']>;
  enable_mmid_tooltip?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Feefo = App & Crm & {
  __typename?: 'Feefo';
  category: AppCategoryType;
  created_at?: Maybe<Scalars['TimeStamp']['output']>;
  handler: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  merchant_identifier: Scalars['String']['output'];
  name: Scalars['String']['output'];
  status?: Maybe<Scalars['Boolean']['output']>;
  type: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['TimeStamp']['output']>;
  used_for_subscription?: Maybe<Scalars['Boolean']['output']>;
};

export type FeefoInput = {
  category: AppCategoryType;
  created_at?: InputMaybe<Scalars['TimeStamp']['input']>;
  handler: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  merchant_identifier: Scalars['String']['input'];
  name: Scalars['String']['input'];
  status?: InputMaybe<Scalars['Boolean']['input']>;
  type: Scalars['String']['input'];
  updated_at?: InputMaybe<Scalars['TimeStamp']['input']>;
  used_for_subscription?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FeefoProductReview = {
  __typename?: 'FeefoProductReview';
  rating?: Maybe<Scalars['Float']['output']>;
  review?: Maybe<Scalars['String']['output']>;
  social?: Maybe<FeefoProductReviewSocial>;
  url?: Maybe<Scalars['String']['output']>;
};

export type FeefoProductReviewSocial = {
  __typename?: 'FeefoProductReviewSocial';
  facebook?: Maybe<Scalars['String']['output']>;
  google_plus?: Maybe<Scalars['String']['output']>;
  twitter?: Maybe<Scalars['String']['output']>;
};

export type FeefoProductReviews = {
  __typename?: 'FeefoProductReviews';
  reviews?: Maybe<Array<Maybe<FeefoProductReview>>>;
  total: Scalars['Int']['output'];
};

export type FileUploadInput = {
  file_name?: InputMaybe<Scalars['String']['input']>;
  file_type?: InputMaybe<Scalars['String']['input']>;
};

export type FileUploadResponse = {
  __typename?: 'FileUploadResponse';
  headers: Array<Maybe<Header>>;
  url: Scalars['String']['output'];
};

export type FlatRateMethod = {
  __typename?: 'FlatRateMethod';
  active?: Maybe<Scalars['Boolean']['output']>;
  all_region?: Maybe<Scalars['Boolean']['output']>;
  apply_type?: Maybe<ApplyType>;
  estimated_days?: Maybe<Scalars['Int']['output']>;
  method?: Maybe<Scalars['String']['output']>;
  minimum_order_amount?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  regions?: Maybe<Array<Maybe<Regions>>>;
  sort?: Maybe<Scalars['Int']['output']>;
};

export type FlatRateMethodInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  all_region?: InputMaybe<Scalars['Boolean']['input']>;
  apply_type?: InputMaybe<ApplyType>;
  estimated_days?: InputMaybe<Scalars['Int']['input']>;
  method?: InputMaybe<Scalars['String']['input']>;
  minimum_order_amount?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
  regions?: InputMaybe<Array<InputMaybe<RegionsInput>>>;
  sort?: InputMaybe<Scalars['Int']['input']>;
};

export type FreeShippingMethod = {
  __typename?: 'FreeShippingMethod';
  active?: Maybe<Scalars['Boolean']['output']>;
  all_region?: Maybe<Scalars['Boolean']['output']>;
  all_zip_codes?: Maybe<Scalars['Boolean']['output']>;
  estimated_days?: Maybe<Scalars['Int']['output']>;
  method?: Maybe<Scalars['String']['output']>;
  minimum_order_amount?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  regions?: Maybe<Array<Maybe<Regions>>>;
  sort?: Maybe<Scalars['Int']['output']>;
  zip_codes?: Maybe<Scalars['String']['output']>;
};

export type FreeShippingMethodInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  all_region?: InputMaybe<Scalars['Boolean']['input']>;
  all_zip_codes?: InputMaybe<Scalars['Boolean']['input']>;
  estimated_days?: InputMaybe<Scalars['Int']['input']>;
  method?: InputMaybe<Scalars['String']['input']>;
  minimum_order_amount?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  regions?: InputMaybe<Array<InputMaybe<RegionsInput>>>;
  sort?: InputMaybe<Scalars['Int']['input']>;
  zip_codes?: InputMaybe<Scalars['String']['input']>;
};

export type FulfilmentCenter = {
  __typename?: 'FulfilmentCenter';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  city_code?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  zipcode?: Maybe<Scalars['String']['output']>;
};

export type FulfilmentCenterInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  city_code?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export enum GenderType {
  Female = 'FEMALE',
  Male = 'MALE',
  Unspecified = 'UNSPECIFIED'
}

export enum GeoType {
  Geofence = 'GEOFENCE',
  Radius = 'RADIUS',
  Zip = 'ZIP'
}

export type GrowthStat = {
  __typename?: 'GrowthStat';
  percentage?: Maybe<Scalars['Float']['output']>;
  revenue?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type Header = {
  __typename?: 'Header';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type HealthCheck = {
  __typename?: 'HealthCheck';
  build_date?: Maybe<Scalars['String']['output']>;
  service_name?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type IdpAccount = {
  __typename?: 'IDPAccount';
  berbix_error?: Maybe<Scalars['String']['output']>;
  berbix_id?: Maybe<Scalars['String']['output']>;
  berbix_verified: Scalars['Boolean']['output'];
  email: Scalars['String']['output'];
  email_verified: Scalars['Boolean']['output'];
  enabled: Scalars['Boolean']['output'];
  id?: Maybe<Scalars['String']['output']>;
  role: Scalars['String']['output'];
};

export type IdScan = App & {
  __typename?: 'IDScan';
  category: AppCategoryType;
  created_at?: Maybe<Scalars['TimeStamp']['output']>;
  handler: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  license_key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  secret_key: Scalars['String']['output'];
  status?: Maybe<Scalars['Boolean']['output']>;
  type: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['TimeStamp']['output']>;
};

export type IdScanInput = {
  category: AppCategoryType;
  created_at?: InputMaybe<Scalars['TimeStamp']['input']>;
  handler: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  license_key: Scalars['String']['input'];
  name: Scalars['String']['input'];
  secret_key: Scalars['String']['input'];
  status?: InputMaybe<Scalars['Boolean']['input']>;
  type: Scalars['String']['input'];
  updated_at?: InputMaybe<Scalars['TimeStamp']['input']>;
};

export type IdScanValidatioTrackStringInput = {
  barcode_params?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<Scalars['String']['input']>;
};

export enum IdScanValidationErrorCode {
  AgeBelowLimit = 'AGE_BELOW_LIMIT',
  AgeNotMatch = 'AGE_NOT_MATCH',
  DocumentExpired = 'DOCUMENT_EXPIRED',
  FaceNotMatch = 'FACE_NOT_MATCH',
  FakeId = 'FAKE_ID',
  FrontImageCannotBeReaded = 'FRONT_IMAGE_CANNOT_BE_READED',
  GenderNotMatch = 'GENDER_NOT_MATCH',
  Unknow = 'UNKNOW'
}

export type IdScanValidationErrorResponse = {
  __typename?: 'IDScanValidationErrorResponse';
  code: IdScanValidationErrorCode;
  text: Scalars['String']['output'];
};

export type IdScanValidationInput = {
  back_or_second_image_base64?: InputMaybe<Scalars['String']['input']>;
  document_type: Scalars['Int']['input'];
  face_image_base64?: InputMaybe<Scalars['String']['input']>;
  front_image_base64?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<IdScanValidationMetadataInput>;
  overridden_settings?: InputMaybe<IdScanValidationOverriddenSettingsInput>;
  ssn?: InputMaybe<Scalars['String']['input']>;
  track_string?: InputMaybe<IdScanValidatioTrackStringInput>;
};

export type IdScanValidationMetadataInput = {
  capture_method?: InputMaybe<Scalars['String']['input']>;
  front_end_metadata?: InputMaybe<Scalars['String']['input']>;
  other_metadata?: InputMaybe<Scalars['String']['input']>;
  user_agent?: InputMaybe<Scalars['String']['input']>;
};

export type IdScanValidationOverriddenSettingsInput = {
  is_back_or_second_image_processing_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  is_face_match_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  is_ocr_enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IdScanValidationResponse = {
  __typename?: 'IDScanValidationResponse';
  error?: Maybe<IdScanValidationErrorResponse>;
  success: Scalars['Boolean']['output'];
};

export type Iterable = App & Crm & {
  __typename?: 'Iterable';
  api_key?: Maybe<Scalars['String']['output']>;
  category: AppCategoryType;
  created_at?: Maybe<Scalars['TimeStamp']['output']>;
  handler: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  settings: Array<IterableSetting>;
  status?: Maybe<Scalars['Boolean']['output']>;
  type: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['TimeStamp']['output']>;
  used_for_subscription?: Maybe<Scalars['Boolean']['output']>;
};

export enum IterableEventType {
  CuoponAdded = 'CUOPON_ADDED',
  OrderApproved = 'ORDER_APPROVED',
  OrderCompleted = 'ORDER_COMPLETED',
  OrderNew = 'ORDER_NEW',
  OrderOnRoute = 'ORDER_ON_ROUTE',
  OrderRejected = 'ORDER_REJECTED',
  ResetUserPasswordConfirmationCode = 'RESET_USER_PASSWORD_CONFIRMATION_CODE',
  ResetUserPasswordTempPassword = 'RESET_USER_PASSWORD_TEMP_PASSWORD',
  UserSignup = 'USER_SIGNUP'
}

export type IterableInput = {
  api_key?: InputMaybe<Scalars['String']['input']>;
  category: AppCategoryType;
  created_at?: InputMaybe<Scalars['TimeStamp']['input']>;
  handler: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  settings: Array<IterableSettingInput>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  type: Scalars['String']['input'];
  updated_at?: InputMaybe<Scalars['TimeStamp']['input']>;
  used_for_subscription?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IterableSetting = {
  __typename?: 'IterableSetting';
  campaign_id: Scalars['Int']['output'];
  event_name?: Maybe<Scalars['String']['output']>;
  event_type: IterableEventType;
  schedule_send_email_hours?: Maybe<Scalars['Int']['output']>;
};

export type IterableSettingInput = {
  campaign_id: Scalars['Int']['input'];
  event_name?: InputMaybe<Scalars['String']['input']>;
  event_type: IterableEventType;
  schedule_send_email_hours?: InputMaybe<Scalars['Int']['input']>;
};

export type Jane = App & {
  __typename?: 'Jane';
  api_key?: Maybe<Scalars['String']['output']>;
  app_id?: Maybe<Scalars['String']['output']>;
  auto_migrate_user?: Maybe<Scalars['Boolean']['output']>;
  category: AppCategoryType;
  client_id?: Maybe<Scalars['String']['output']>;
  client_secret?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['TimeStamp']['output']>;
  handler: Scalars['String']['output'];
  host?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  operation_client_id?: Maybe<Scalars['String']['output']>;
  operation_client_secret?: Maybe<Scalars['String']['output']>;
  product_index?: Maybe<Scalars['String']['output']>;
  reviews_index?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
  store_id?: Maybe<Scalars['String']['output']>;
  stores_index?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['TimeStamp']['output']>;
};

export type JaneBestProductBundlePosibility = {
  __typename?: 'JaneBestProductBundlePosibility';
  discountable_product_ids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  special_id?: Maybe<Scalars['String']['output']>;
  status?: Maybe<JaneBundlePosibilityStatus>;
};

export type JaneBestProductBundlePosibilityInput = {
  count: Scalars['Int']['input'];
  price_id: JanePriceId;
  product_id: Scalars['String']['input'];
};

export enum JaneBundlePosibilityStatus {
  Applied = 'applied',
  PartiallyQualified = 'partially_qualified',
  Qualified = 'qualified'
}

export type JaneBundleSetting = {
  __typename?: 'JaneBundleSetting';
  brands?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  kinds?: Maybe<Array<Maybe<JaneSpecialKind>>>;
  max_number_of_discounted_products?: Maybe<Scalars['Int']['output']>;
  products_ids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  threshold_number_of_items_in_cart?: Maybe<Scalars['Int']['output']>;
  weights?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type JaneBundleSpecialSetting = {
  __typename?: 'JaneBundleSpecialSetting';
  allow_discounts_on_required_products?: Maybe<Scalars['Boolean']['output']>;
  dependent?: Maybe<JaneBundleSetting>;
  independent?: Maybe<JaneBundleSetting>;
  max_applications_per_cart?: Maybe<Scalars['Int']['output']>;
};

export type JaneInput = {
  api_key: Scalars['String']['input'];
  app_id: Scalars['String']['input'];
  auto_migrate_user: Scalars['Boolean']['input'];
  category: AppCategoryType;
  client_id: Scalars['String']['input'];
  client_secret: Scalars['String']['input'];
  created_at?: InputMaybe<Scalars['TimeStamp']['input']>;
  handler: Scalars['String']['input'];
  host: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  operation_client_id: Scalars['String']['input'];
  operation_client_secret: Scalars['String']['input'];
  product_index: Scalars['String']['input'];
  reviews_index: Scalars['String']['input'];
  status?: InputMaybe<Scalars['Boolean']['input']>;
  store_id: Scalars['String']['input'];
  stores_index: Scalars['String']['input'];
  type: Scalars['String']['input'];
  updated_at?: InputMaybe<Scalars['TimeStamp']['input']>;
};

export enum JanePriceId {
  Each = 'each',
  EighthOunce = 'eighth_ounce',
  Gram = 'gram',
  HalfGram = 'half_gram',
  HalfOunce = 'half_ounce',
  Ounce = 'ounce',
  QuarterOunce = 'quarter_ounce',
  TwoGram = 'two_gram'
}

export type JaneProductReview = {
  __typename?: 'JaneProductReview';
  avatar: Scalars['Float']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['String']['output'];
  has_comment: Scalars['Boolean']['output'];
  nickname: Scalars['String']['output'];
  rating: Scalars['Float']['output'];
  updated_at: Scalars['String']['output'];
  upvote_count: Scalars['Float']['output'];
};

export type JaneSpecial = {
  __typename?: 'JaneSpecial';
  asset?: Maybe<Asset>;
  brands?: Maybe<Array<Scalars['String']['output']>>;
  bundle_products?: Maybe<Array<Scalars['String']['output']>>;
  description?: Maybe<Scalars['String']['output']>;
  discount_dollar_amount?: Maybe<Scalars['Int']['output']>;
  discount_percent?: Maybe<Scalars['Int']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  enabled_friday?: Maybe<Scalars['Boolean']['output']>;
  enabled_monday?: Maybe<Scalars['Boolean']['output']>;
  enabled_saturday?: Maybe<Scalars['Boolean']['output']>;
  enabled_sunday?: Maybe<Scalars['Boolean']['output']>;
  enabled_thursday?: Maybe<Scalars['Boolean']['output']>;
  enabled_tuesday?: Maybe<Scalars['Boolean']['output']>;
  enabled_wednesday?: Maybe<Scalars['Boolean']['output']>;
  end_date?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  kinds?: Maybe<Array<JaneSpecialKind>>;
  promo_code?: Maybe<Scalars['String']['output']>;
  setting?: Maybe<JaneBundleSpecialSetting>;
  special_type?: Maybe<Scalars['String']['output']>;
  start_date?: Maybe<Scalars['String']['output']>;
  store_id?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type JaneSpecialKind = {
  __typename?: 'JaneSpecialKind';
  brand_subtype?: Maybe<Scalars['String']['output']>;
  kind?: Maybe<Scalars['String']['output']>;
  root_subtype?: Maybe<Scalars['String']['output']>;
};

export type JaneStore = {
  __typename?: 'JaneStore';
  city?: Maybe<Scalars['String']['output']>;
  delivery?: Maybe<Scalars['Boolean']['output']>;
  delivery_hours?: Maybe<Array<Maybe<JaneStoreWorkingHour>>>;
  delivery_radius?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  full_address?: Maybe<Scalars['String']['output']>;
  google_map_url?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  medical?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  photo?: Maybe<Scalars['String']['output']>;
  pickup?: Maybe<Scalars['Boolean']['output']>;
  pickup_hours?: Maybe<Array<Maybe<JaneStoreWorkingHour>>>;
  products_count?: Maybe<Scalars['Int']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  recreational?: Maybe<Scalars['Boolean']['output']>;
  reviews?: Maybe<Scalars['Int']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  working_hours?: Maybe<Array<Maybe<JaneStoreWorkingHour>>>;
};

export type JaneStoreWorkingHour = {
  __typename?: 'JaneStoreWorkingHour';
  day?: Maybe<Scalars['String']['output']>;
  from?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Scalars['String']['output']>;
};

export type Klaviyo = App & Crm & {
  __typename?: 'Klaviyo';
  category: AppCategoryType;
  created_at?: Maybe<Scalars['TimeStamp']['output']>;
  handler: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  lists: Array<KlaviyoList>;
  name: Scalars['String']['output'];
  private_key: Scalars['String']['output'];
  status?: Maybe<Scalars['Boolean']['output']>;
  type: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['TimeStamp']['output']>;
  used_for_subscription?: Maybe<Scalars['Boolean']['output']>;
};

export type KlaviyoInput = {
  category: AppCategoryType;
  created_at?: InputMaybe<Scalars['TimeStamp']['input']>;
  handler: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  lists: Array<KlaviyoListInput>;
  name: Scalars['String']['input'];
  private_key: Scalars['String']['input'];
  status?: InputMaybe<Scalars['Boolean']['input']>;
  type: Scalars['String']['input'];
  updated_at?: InputMaybe<Scalars['TimeStamp']['input']>;
  used_for_subscription?: InputMaybe<Scalars['Boolean']['input']>;
};

export type KlaviyoList = {
  __typename?: 'KlaviyoList';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type KlaviyoListInput = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type Landing = {
  __typename?: 'Landing';
  id?: Maybe<Scalars['String']['output']>;
  project?: Maybe<Scalars['String']['output']>;
  published?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type LandingInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  project?: InputMaybe<Scalars['String']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type LeafLogix = App & {
  __typename?: 'LeafLogix';
  category: AppCategoryType;
  created_at?: Maybe<Scalars['TimeStamp']['output']>;
  handler: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  internal_api_key?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  status?: Maybe<Scalars['Boolean']['output']>;
  type: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['TimeStamp']['output']>;
};

export type LeafLogixInput = {
  category: AppCategoryType;
  created_at?: InputMaybe<Scalars['TimeStamp']['input']>;
  handler: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  internal_api_key?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  status?: InputMaybe<Scalars['Boolean']['input']>;
  type: Scalars['String']['input'];
  updated_at?: InputMaybe<Scalars['TimeStamp']['input']>;
};

export type LineItem = {
  __typename?: 'LineItem';
  barcodes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  base_weight?: Maybe<Scalars['Float']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  height_unit?: Maybe<DimensionUnitType>;
  id?: Maybe<Scalars['String']['output']>;
  in_stock?: Maybe<Scalars['Boolean']['output']>;
  item_id?: Maybe<Scalars['String']['output']>;
  length?: Maybe<Scalars['Float']['output']>;
  length_unit?: Maybe<DimensionUnitType>;
  name?: Maybe<Scalars['String']['output']>;
  pos_id?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  price_type?: Maybe<PriceType>;
  product_height?: Maybe<Scalars['Float']['output']>;
  product_width?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  sale_price?: Maybe<Scalars['Int']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  tier_method?: Maybe<TierMethod>;
  variants?: Maybe<Array<Maybe<Variant>>>;
  weight?: Maybe<Scalars['Float']['output']>;
  weight_unit?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
  width_unit?: Maybe<DimensionUnitType>;
};

export type LineItemInput = {
  barcodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  base_weight?: InputMaybe<Scalars['Float']['input']>;
  brand?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  height_unit?: InputMaybe<DimensionUnitType>;
  id?: InputMaybe<Scalars['String']['input']>;
  item_id?: InputMaybe<Scalars['String']['input']>;
  length?: InputMaybe<Scalars['Float']['input']>;
  length_unit?: InputMaybe<DimensionUnitType>;
  name?: InputMaybe<Scalars['String']['input']>;
  pos_id?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
  price_type?: InputMaybe<PriceType>;
  product_height?: InputMaybe<Scalars['Float']['input']>;
  product_width?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  sale_price?: InputMaybe<Scalars['Int']['input']>;
  thumbnail?: InputMaybe<Scalars['String']['input']>;
  tier_method?: InputMaybe<TierMethod>;
  variants?: InputMaybe<Array<InputMaybe<VariantInput>>>;
  weight?: InputMaybe<Scalars['Float']['input']>;
  weight_unit?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
  width_unit?: InputMaybe<DimensionUnitType>;
};

export enum LisTrackEventType {
  CuoponAdded = 'CUOPON_ADDED',
  OrderApproved = 'ORDER_APPROVED',
  OrderApprovedDelivery = 'ORDER_APPROVED_DELIVERY',
  OrderApprovedPickup = 'ORDER_APPROVED_PICKUP',
  OrderCompleted = 'ORDER_COMPLETED',
  OrderCompletedDelivery = 'ORDER_COMPLETED_DELIVERY',
  OrderCompletedPickup = 'ORDER_COMPLETED_PICKUP',
  OrderNew = 'ORDER_NEW',
  OrderNewDelivery = 'ORDER_NEW_DELIVERY',
  OrderNewPickup = 'ORDER_NEW_PICKUP',
  OrderOnRoute = 'ORDER_ON_ROUTE',
  OrderRejected = 'ORDER_REJECTED',
  OrderRejectedDelivery = 'ORDER_REJECTED_DELIVERY',
  OrderRejectedPickup = 'ORDER_REJECTED_PICKUP',
  ResetUserPasswordConfirmationCode = 'RESET_USER_PASSWORD_CONFIRMATION_CODE',
  ResetUserPasswordTempPassword = 'RESET_USER_PASSWORD_TEMP_PASSWORD',
  UserSignup = 'USER_SIGNUP'
}

export type ListTrack = App & Crm & {
  __typename?: 'ListTrack';
  category: AppCategoryType;
  client_id: Scalars['String']['output'];
  client_secret: Scalars['String']['output'];
  created_at?: Maybe<Scalars['TimeStamp']['output']>;
  data_client_id: Scalars['String']['output'];
  data_client_secret: Scalars['String']['output'];
  handler: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  list_id: Scalars['String']['output'];
  messages: Array<ListTrackMessage>;
  name: Scalars['String']['output'];
  order_fields?: Maybe<Array<ListTrackField>>;
  password_fields?: Maybe<Array<ListTrackField>>;
  sources?: Maybe<Array<ListTrackSourceFields>>;
  status?: Maybe<Scalars['Boolean']['output']>;
  store_fields?: Maybe<Array<ListTrackField>>;
  subscribe_fields?: Maybe<Array<ListTrackField>>;
  subscribe_lists?: Maybe<Array<ListTrackField>>;
  type: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['TimeStamp']['output']>;
  used_for_subscription?: Maybe<Scalars['Boolean']['output']>;
};

export type ListTrackField = {
  __typename?: 'ListTrackField';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type ListTrackFieldInput = {
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

export type ListTrackInput = {
  category: AppCategoryType;
  client_id: Scalars['String']['input'];
  client_secret: Scalars['String']['input'];
  created_at?: InputMaybe<Scalars['TimeStamp']['input']>;
  data_client_id: Scalars['String']['input'];
  data_client_secret: Scalars['String']['input'];
  handler: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  list_id: Scalars['String']['input'];
  messages: Array<ListTrackMessagenput>;
  name: Scalars['String']['input'];
  order_fields?: InputMaybe<Array<ListTrackFieldInput>>;
  password_fields?: InputMaybe<Array<ListTrackFieldInput>>;
  sources?: InputMaybe<Array<ListTrackSourceFieldsInput>>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  store_fields?: InputMaybe<Array<ListTrackFieldInput>>;
  subscribe_fields?: InputMaybe<Array<ListTrackFieldInput>>;
  subscribe_lists?: InputMaybe<Array<ListTrackFieldInput>>;
  type: Scalars['String']['input'];
  updated_at?: InputMaybe<Scalars['TimeStamp']['input']>;
  used_for_subscription?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ListTrackMessage = {
  __typename?: 'ListTrackMessage';
  event_type: LisTrackEventType;
  message_id: Scalars['String']['output'];
};

export type ListTrackMessagenput = {
  event_type: LisTrackEventType;
  message_id: Scalars['String']['input'];
};

export type ListTrackSourceFields = {
  __typename?: 'ListTrackSourceFields';
  event_id: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  type: SubscriptionSourceType;
};

export type ListTrackSourceFieldsInput = {
  event_id: Scalars['String']['input'];
  id: Scalars['Int']['input'];
  type: SubscriptionSourceType;
};

export type LocalDelivery = {
  __typename?: 'LocalDelivery';
  active?: Maybe<Scalars['Boolean']['output']>;
  estimated_days?: Maybe<Scalars['Int']['output']>;
  information?: Maybe<Scalars['String']['output']>;
  minimum_order_amount?: Maybe<Scalars['Int']['output']>;
  minimum_order_required?: Maybe<Scalars['Boolean']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  zip_codes?: Maybe<Scalars['String']['output']>;
};

export type LocalDeliveryInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  estimated_days?: InputMaybe<Scalars['Int']['input']>;
  information?: InputMaybe<Scalars['String']['input']>;
  minimum_order_amount?: InputMaybe<Scalars['Int']['input']>;
  minimum_order_required?: InputMaybe<Scalars['Boolean']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
  zip_codes?: InputMaybe<Scalars['String']['input']>;
};

export type LocalPickUp = {
  __typename?: 'LocalPickUp';
  active?: Maybe<Scalars['Boolean']['output']>;
  pickup_time?: Maybe<Scalars['String']['output']>;
  zip_codes?: Maybe<Scalars['String']['output']>;
};

export type LocalPickUpInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  pickup_time?: InputMaybe<Scalars['String']['input']>;
  zip_codes?: InputMaybe<Scalars['String']['input']>;
};

export type LoyaltyPointsTimeLine = {
  __typename?: 'LoyaltyPointsTimeLine';
  date?: Maybe<Scalars['TimeStamp']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  points: Scalars['Float']['output'];
};

export type MenuItem = {
  __typename?: 'MenuItem';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parent_menu_item_id?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  target?: Maybe<Target>;
  url?: Maybe<Scalars['String']['output']>;
};

export type MenuItemInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parent_menu_item_id?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  target?: InputMaybe<Target>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export enum MenuType {
  Express = 'EXPRESS',
  ScheduleDelivery = 'SCHEDULE_DELIVERY'
}

export type Metafield = App & {
  __typename?: 'Metafield';
  category: AppCategoryType;
  created_at?: Maybe<Scalars['TimeStamp']['output']>;
  handler: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  metafield?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  status?: Maybe<Scalars['Boolean']['output']>;
  type: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['TimeStamp']['output']>;
};

export type MetafieldInput = {
  category: AppCategoryType;
  created_at?: InputMaybe<Scalars['TimeStamp']['input']>;
  handler: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  metafield?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  status?: InputMaybe<Scalars['Boolean']['input']>;
  type: Scalars['String']['input'];
  updated_at?: InputMaybe<Scalars['TimeStamp']['input']>;
};

export type MinByZipCodeInput = {
  category: AppCategoryType;
  created_at?: InputMaybe<Scalars['TimeStamp']['input']>;
  handler: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  locations: Array<MinZipByCodeLocationInput>;
  name: Scalars['String']['input'];
  status?: InputMaybe<Scalars['Boolean']['input']>;
  type: Scalars['String']['input'];
  updated_at?: InputMaybe<Scalars['TimeStamp']['input']>;
};

export type MinZipByCode = App & {
  __typename?: 'MinZipByCode';
  category: AppCategoryType;
  created_at?: Maybe<Scalars['TimeStamp']['output']>;
  handler: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  locations: Array<MinZipByCodeLocation>;
  name: Scalars['String']['output'];
  status?: Maybe<Scalars['Boolean']['output']>;
  type: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['TimeStamp']['output']>;
};

export type MinZipByCodeLocation = {
  __typename?: 'MinZipByCodeLocation';
  amount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  zips: Array<Scalars['String']['output']>;
};

export type MinZipByCodeLocationInput = {
  amount: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  zips: Array<Scalars['String']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  activateAppForStore?: Maybe<App>;
  addAeropayPaymentDetailToOrder?: Maybe<Order>;
  addNotesToAccount?: Maybe<Account>;
  applyPromoCode?: Maybe<OrderDiscountItem>;
  checkOrderLineItemsBarCodes?: Maybe<Scalars['Boolean']['output']>;
  createAccount?: Maybe<Account>;
  createApp?: Maybe<App>;
  createBerbixClientToken?: Maybe<BerbixClientToken>;
  createBusinessAccount?: Maybe<BusinessAccount>;
  createFacebookCatalogProducts?: Maybe<Scalars['String']['output']>;
  createLanding?: Maybe<Landing>;
  createNavigation?: Maybe<Navigation>;
  createNotificationSetting?: Maybe<NotificationSetting>;
  createOption?: Maybe<Option>;
  createOrder?: Maybe<Order>;
  createPage?: Maybe<Page>;
  createPromotion?: Maybe<Promotion>;
  createStore?: Maybe<Store>;
  createStoreAsync?: Maybe<Scalars['Boolean']['output']>;
  createStrongholdPayLink?: Maybe<CreateStrongholdPayLinkResponse>;
  createSwifterSession: PaymentDetail;
  createTag?: Maybe<Tag>;
  createUser?: Maybe<User>;
  customerCancelOrder?: Maybe<Order>;
  deactivateAppForStore?: Maybe<App>;
  deleteLanding?: Maybe<Scalars['String']['output']>;
  deleteNavigation?: Maybe<Scalars['String']['output']>;
  deleteOption?: Maybe<Scalars['String']['output']>;
  deletePage?: Maybe<Scalars['String']['output']>;
  deletePromotion?: Maybe<Scalars['String']['output']>;
  deleteStore?: Maybe<Scalars['String']['output']>;
  deleteTag?: Maybe<Scalars['String']['output']>;
  generateTempPass?: Maybe<Scalars['String']['output']>;
  idScanVerification?: Maybe<IdScanValidationResponse>;
  migrateUser?: Maybe<Scalars['Boolean']['output']>;
  migrateUserFromReset?: Maybe<Scalars['Boolean']['output']>;
  publishLanding?: Maybe<Scalars['String']['output']>;
  publishStores?: Maybe<Scalars['String']['output']>;
  removeBusinessAccount?: Maybe<Scalars['String']['output']>;
  resetUserPassword?: Maybe<Scalars['Boolean']['output']>;
  sendContactEmail?: Maybe<Scalars['String']['output']>;
  sendForgotUserPassword?: Maybe<Scalars['Boolean']['output']>;
  setDefaultNotificationSettings?: Maybe<Array<Maybe<NotificationSetting>>>;
  setTreezCustomerUnverified?: Maybe<Scalars['Boolean']['output']>;
  submitCart?: Maybe<Scalars['String']['output']>;
  submitKioskCheckout?: Maybe<Scalars['String']['output']>;
  submitSwifterPayment: PaymentDetail;
  subscribeToCRM?: Maybe<Scalars['Boolean']['output']>;
  subscribeUser?: Maybe<Scalars['String']['output']>;
  syncFromBlaze?: Maybe<Scalars['Boolean']['output']>;
  syncFromJane?: Maybe<Scalars['Boolean']['output']>;
  syncFromLeafLogic?: Maybe<Scalars['Boolean']['output']>;
  syncFromTreez?: Maybe<Scalars['Boolean']['output']>;
  syncJaneProductToLisTrack?: Maybe<Scalars['Boolean']['output']>;
  updateAccount?: Maybe<Account>;
  updateAccountBerbixVerification?: Maybe<Scalars['Boolean']['output']>;
  updateAeropayApp?: Maybe<App>;
  updateAlpineIQApp?: Maybe<App>;
  updateApp?: Maybe<App>;
  updateBerbixApp?: Maybe<App>;
  updateBlazeApp?: Maybe<App>;
  updateBrand?: Maybe<Brand>;
  updateBusinessAccount?: Maybe<BusinessAccount>;
  updateCart?: Maybe<Order>;
  updateCategory?: Maybe<Category>;
  updateCovaApp?: Maybe<App>;
  updateDutchieApp?: Maybe<App>;
  updateDutchieCart?: Maybe<UpdateDutchieCartResponse>;
  updateFacebookCatalogApp?: Maybe<App>;
  updateFeefoApp?: Maybe<App>;
  updateIDPAccount?: Maybe<Scalars['Boolean']['output']>;
  updateIDScanApp?: Maybe<App>;
  updateIterableApp?: Maybe<App>;
  updateJaneApp?: Maybe<App>;
  updateJaneCart?: Maybe<Order>;
  updateKlaviyoApp?: Maybe<App>;
  updateLanding?: Maybe<Landing>;
  updateLeafLogixApp?: Maybe<App>;
  updateListTrackApp?: Maybe<App>;
  updateMetafieldApp?: Maybe<App>;
  updateMinZipByCodeApp?: Maybe<App>;
  updateNavigation?: Maybe<Navigation>;
  updateNotificationSetting?: Maybe<NotificationSetting>;
  updateOmnisendApp?: Maybe<App>;
  updateOnFleetApp?: Maybe<App>;
  updateOption?: Maybe<Option>;
  updateOrder?: Maybe<Order>;
  updateOrderDetails?: Maybe<Order>;
  updateOrderLineItemsBarCodes?: Maybe<Order>;
  updateOrderStatus?: Maybe<Order>;
  updatePage?: Maybe<Page>;
  updateProduct?: Maybe<Product>;
  updatePromotion?: Maybe<Promotion>;
  updateRedirectApp?: Maybe<App>;
  updateReverseProxyApp?: Maybe<App>;
  updateStore?: Maybe<Store>;
  updateStoreNotificationSetting?: Maybe<NotificationSetting>;
  updateStrongholdApp?: Maybe<App>;
  updateStrongholdChargeId?: Maybe<Scalars['String']['output']>;
  updateSurfsideApp?: Maybe<App>;
  updateSwifterApp?: Maybe<App>;
  updateTag?: Maybe<Tag>;
  updateTreezApp?: Maybe<App>;
  updateTreezCart?: Maybe<UpdateTreezCartResponse>;
  updateTreezPayApp?: Maybe<App>;
  updateUser?: Maybe<User>;
  uploadAccountPhoto?: Maybe<UploadAccountPhotoResponse>;
  uploadFile?: Maybe<FileUploadResponse>;
};


export type MutationActivateAppForStoreArgs = {
  account_id: Scalars['String']['input'];
  input: SystemAppInput;
  store_id: Scalars['String']['input'];
};


export type MutationAddAeropayPaymentDetailToOrderArgs = {
  account_id: Scalars['String']['input'];
  input: AddAeroPayPaymentDetailInput;
  store_id: Scalars['String']['input'];
};


export type MutationAddNotesToAccountArgs = {
  account_id: Scalars['String']['input'];
  input: AddAccountNotesInput;
  store_id: Scalars['String']['input'];
};


export type MutationApplyPromoCodeArgs = {
  account_id: Scalars['String']['input'];
  order_id: Scalars['String']['input'];
  promo_code: Scalars['String']['input'];
  store_id: Scalars['String']['input'];
};


export type MutationCheckOrderLineItemsBarCodesArgs = {
  account_id: Scalars['String']['input'];
  input: UpdateOrderLineItemsBarCodesInput;
  store_id: Scalars['String']['input'];
};


export type MutationCreateAccountArgs = {
  account_id: Scalars['String']['input'];
  input: CreateAccountInput;
  store_id: Scalars['String']['input'];
};


export type MutationCreateAppArgs = {
  input: SystemAppInput;
};


export type MutationCreateBerbixClientTokenArgs = {
  account_id: Scalars['String']['input'];
  input: BerbixClientTokenInput;
  store_id: Scalars['String']['input'];
};


export type MutationCreateBusinessAccountArgs = {
  input: BusinessAccountInput;
};


export type MutationCreateFacebookCatalogProductsArgs = {
  account_id: Scalars['String']['input'];
  store_id: Scalars['String']['input'];
};


export type MutationCreateLandingArgs = {
  account_id: Scalars['String']['input'];
  input: LandingInput;
  store_id: Scalars['String']['input'];
};


export type MutationCreateNavigationArgs = {
  account_id: Scalars['String']['input'];
  input: NavigationInput;
  store_id: Scalars['String']['input'];
};


export type MutationCreateNotificationSettingArgs = {
  input: NotificationSettingInput;
};


export type MutationCreateOptionArgs = {
  account_id: Scalars['String']['input'];
  input: OptionInput;
  store_id: Scalars['String']['input'];
};


export type MutationCreateOrderArgs = {
  account_id: Scalars['String']['input'];
  input: OrderInput;
  store_id: Scalars['String']['input'];
};


export type MutationCreatePageArgs = {
  account_id: Scalars['String']['input'];
  input: PageInput;
  store_id: Scalars['String']['input'];
};


export type MutationCreatePromotionArgs = {
  account_id: Scalars['String']['input'];
  input: PromotionInput;
  store_id: Scalars['String']['input'];
};


export type MutationCreateStoreArgs = {
  account_id: Scalars['String']['input'];
  input: StoreInput;
};


export type MutationCreateStoreAsyncArgs = {
  account_id: Scalars['String']['input'];
  input: StoreInput;
};


export type MutationCreateStrongholdPayLinkArgs = {
  account_id: Scalars['String']['input'];
  input: CreateStrongholdPayLinkInput;
  store_id: Scalars['String']['input'];
};


export type MutationCreateSwifterSessionArgs = {
  account_id: Scalars['String']['input'];
  input: CreateSwifterSessionInput;
  store_id: Scalars['String']['input'];
};


export type MutationCreateTagArgs = {
  account_id: Scalars['String']['input'];
  input: TagInput;
  store_id: Scalars['String']['input'];
};


export type MutationCreateUserArgs = {
  input: UserInput;
};


export type MutationCustomerCancelOrderArgs = {
  account_id: Scalars['String']['input'];
  entity_id: Scalars['String']['input'];
  store_id: Scalars['String']['input'];
};


export type MutationDeactivateAppForStoreArgs = {
  account_id: Scalars['String']['input'];
  input: SystemAppInput;
  store_id: Scalars['String']['input'];
};


export type MutationDeleteLandingArgs = {
  account_id: Scalars['String']['input'];
  input: LandingInput;
  store_id: Scalars['String']['input'];
};


export type MutationDeleteNavigationArgs = {
  account_id: Scalars['String']['input'];
  input: NavigationInput;
  store_id: Scalars['String']['input'];
};


export type MutationDeleteOptionArgs = {
  account_id: Scalars['String']['input'];
  option_id: Scalars['String']['input'];
  store_id: Scalars['String']['input'];
};


export type MutationDeletePageArgs = {
  account_id: Scalars['String']['input'];
  input: PageInput;
  store_id: Scalars['String']['input'];
};


export type MutationDeletePromotionArgs = {
  account_id: Scalars['String']['input'];
  id: Scalars['String']['input'];
  store_id: Scalars['String']['input'];
};


export type MutationDeleteStoreArgs = {
  account_id: Scalars['String']['input'];
  store_id: Scalars['String']['input'];
};


export type MutationDeleteTagArgs = {
  account_id: Scalars['String']['input'];
  input: TagInput;
  store_id: Scalars['String']['input'];
};


export type MutationGenerateTempPassArgs = {
  input: UserInput;
};


export type MutationIdScanVerificationArgs = {
  account_id: Scalars['String']['input'];
  input: IdScanValidationInput;
  store_id: Scalars['String']['input'];
};


export type MutationMigrateUserArgs = {
  account_id: Scalars['String']['input'];
  password: Scalars['String']['input'];
  store_id: Scalars['String']['input'];
  username: Scalars['String']['input'];
};


export type MutationMigrateUserFromResetArgs = {
  account_id: Scalars['String']['input'];
  store_id: Scalars['String']['input'];
  username: Scalars['String']['input'];
};


export type MutationPublishLandingArgs = {
  account_id: Scalars['String']['input'];
  input: LandingInput;
  store_id: Scalars['String']['input'];
};


export type MutationPublishStoresArgs = {
  account_id: Scalars['String']['input'];
  store_id: Scalars['String']['input'];
};


export type MutationRemoveBusinessAccountArgs = {
  id: Scalars['String']['input'];
};


export type MutationResetUserPasswordArgs = {
  account_id: Scalars['String']['input'];
  input: ResetUserPasswordInput;
  store_id: Scalars['String']['input'];
};


export type MutationSendContactEmailArgs = {
  account_id: Scalars['String']['input'];
  input: ContactInput;
  store_id: Scalars['String']['input'];
};


export type MutationSendForgotUserPasswordArgs = {
  account_id: Scalars['String']['input'];
  email: Scalars['String']['input'];
  store_id: Scalars['String']['input'];
};


export type MutationSetDefaultNotificationSettingsArgs = {
  account_id: Scalars['String']['input'];
  store_id: Scalars['String']['input'];
};


export type MutationSubmitCartArgs = {
  account_id: Scalars['String']['input'];
  entity_id: Scalars['String']['input'];
  store_id: Scalars['String']['input'];
};


export type MutationSubmitKioskCheckoutArgs = {
  account_id: Scalars['String']['input'];
  input: UpdateCartInput;
  store_id: Scalars['String']['input'];
};


export type MutationSubmitSwifterPaymentArgs = {
  account_id: Scalars['String']['input'];
  entity_id: Scalars['String']['input'];
  store_id: Scalars['String']['input'];
};


export type MutationSubscribeToCrmArgs = {
  account_id: Scalars['String']['input'];
  input: SubscribeCrmInput;
  store_id: Scalars['String']['input'];
};


export type MutationSubscribeUserArgs = {
  account_id: Scalars['String']['input'];
  input: SubscriptionInput;
  store_id: Scalars['String']['input'];
};


export type MutationSyncFromBlazeArgs = {
  account_id: Scalars['String']['input'];
  store_id: Scalars['String']['input'];
};


export type MutationSyncFromJaneArgs = {
  account_id: Scalars['String']['input'];
  store_id: Scalars['String']['input'];
};


export type MutationSyncFromLeafLogicArgs = {
  account_id: Scalars['String']['input'];
  store_id: Scalars['String']['input'];
};


export type MutationSyncFromTreezArgs = {
  account_id: Scalars['String']['input'];
  store_id: Scalars['String']['input'];
};


export type MutationSyncJaneProductToLisTrackArgs = {
  account_id: Scalars['String']['input'];
  jane_store_id: Scalars['String']['input'];
  store_id: Scalars['String']['input'];
};


export type MutationUpdateAccountArgs = {
  account_id: Scalars['String']['input'];
  input: UpdateAccountInput;
  store_id: Scalars['String']['input'];
};


export type MutationUpdateAccountBerbixVerificationArgs = {
  account_id: Scalars['String']['input'];
  input: UpdateBerbixVerificationStatus;
  store_id: Scalars['String']['input'];
};


export type MutationUpdateAeropayAppArgs = {
  account_id: Scalars['String']['input'];
  input: AeropayInput;
  store_id: Scalars['String']['input'];
};


export type MutationUpdateAlpineIqAppArgs = {
  account_id: Scalars['String']['input'];
  input: AlpineIqInput;
  store_id: Scalars['String']['input'];
};


export type MutationUpdateAppArgs = {
  input: SystemAppInput;
};


export type MutationUpdateBerbixAppArgs = {
  account_id: Scalars['String']['input'];
  input: BerbixInput;
  store_id: Scalars['String']['input'];
};


export type MutationUpdateBlazeAppArgs = {
  account_id: Scalars['String']['input'];
  input: BlazeInput;
  store_id: Scalars['String']['input'];
};


export type MutationUpdateBrandArgs = {
  account_id: Scalars['String']['input'];
  input: BrandInput;
  store_id: Scalars['String']['input'];
};


export type MutationUpdateBusinessAccountArgs = {
  input: BusinessAccountInput;
};


export type MutationUpdateCartArgs = {
  account_id: Scalars['String']['input'];
  input: UpdateCartInput;
  store_id: Scalars['String']['input'];
};


export type MutationUpdateCategoryArgs = {
  account_id: Scalars['String']['input'];
  input: CategoryInput;
  store_id: Scalars['String']['input'];
};


export type MutationUpdateCovaAppArgs = {
  account_id: Scalars['String']['input'];
  input: CovaInput;
  store_id: Scalars['String']['input'];
};


export type MutationUpdateDutchieAppArgs = {
  account_id: Scalars['String']['input'];
  input: DutchieInput;
  store_id: Scalars['String']['input'];
};


export type MutationUpdateDutchieCartArgs = {
  account_id: Scalars['String']['input'];
  input: UpdateCartInput;
  store_id: Scalars['String']['input'];
};


export type MutationUpdateFacebookCatalogAppArgs = {
  account_id: Scalars['String']['input'];
  input: FacebookCatalogInput;
  store_id: Scalars['String']['input'];
};


export type MutationUpdateFeefoAppArgs = {
  account_id: Scalars['String']['input'];
  input: FeefoInput;
  store_id: Scalars['String']['input'];
};


export type MutationUpdateIdpAccountArgs = {
  account_id: Scalars['String']['input'];
  input: UpdateIdpAccount;
  store_id: Scalars['String']['input'];
};


export type MutationUpdateIdScanAppArgs = {
  account_id: Scalars['String']['input'];
  input: IdScanInput;
  store_id: Scalars['String']['input'];
};


export type MutationUpdateIterableAppArgs = {
  account_id: Scalars['String']['input'];
  input: IterableInput;
  store_id: Scalars['String']['input'];
};


export type MutationUpdateJaneAppArgs = {
  account_id: Scalars['String']['input'];
  input: JaneInput;
  store_id: Scalars['String']['input'];
};


export type MutationUpdateJaneCartArgs = {
  account_id: Scalars['String']['input'];
  input: UpdateCartInput;
  store_id: Scalars['String']['input'];
};


export type MutationUpdateKlaviyoAppArgs = {
  account_id: Scalars['String']['input'];
  input: KlaviyoInput;
  store_id: Scalars['String']['input'];
};


export type MutationUpdateLandingArgs = {
  account_id: Scalars['String']['input'];
  input: LandingInput;
  store_id: Scalars['String']['input'];
};


export type MutationUpdateLeafLogixAppArgs = {
  account_id: Scalars['String']['input'];
  input: LeafLogixInput;
  store_id: Scalars['String']['input'];
};


export type MutationUpdateListTrackAppArgs = {
  account_id: Scalars['String']['input'];
  input: ListTrackInput;
  store_id: Scalars['String']['input'];
};


export type MutationUpdateMetafieldAppArgs = {
  account_id: Scalars['String']['input'];
  input: MetafieldInput;
  store_id: Scalars['String']['input'];
};


export type MutationUpdateMinZipByCodeAppArgs = {
  account_id: Scalars['String']['input'];
  input: MinByZipCodeInput;
  store_id: Scalars['String']['input'];
};


export type MutationUpdateNavigationArgs = {
  account_id: Scalars['String']['input'];
  input: NavigationInput;
  store_id: Scalars['String']['input'];
};


export type MutationUpdateNotificationSettingArgs = {
  input: NotificationSettingInput;
};


export type MutationUpdateOmnisendAppArgs = {
  account_id: Scalars['String']['input'];
  input: OmnisendInput;
  store_id: Scalars['String']['input'];
};


export type MutationUpdateOnFleetAppArgs = {
  account_id: Scalars['String']['input'];
  input: OnFleetInput;
  store_id: Scalars['String']['input'];
};


export type MutationUpdateOptionArgs = {
  account_id: Scalars['String']['input'];
  input: OptionInput;
  store_id: Scalars['String']['input'];
};


export type MutationUpdateOrderArgs = {
  account_id: Scalars['String']['input'];
  input: OrderInput;
  store_id: Scalars['String']['input'];
};


export type MutationUpdateOrderDetailsArgs = {
  account_id: Scalars['String']['input'];
  input: UpdateOrderDetailsInput;
  store_id: Scalars['String']['input'];
};


export type MutationUpdateOrderLineItemsBarCodesArgs = {
  account_id: Scalars['String']['input'];
  input: UpdateOrderLineItemsBarCodesInput;
  store_id: Scalars['String']['input'];
};


export type MutationUpdateOrderStatusArgs = {
  account_id: Scalars['String']['input'];
  input: UpdateOrderStatusInput;
  store_id: Scalars['String']['input'];
};


export type MutationUpdatePageArgs = {
  account_id: Scalars['String']['input'];
  input: PageInput;
  store_id: Scalars['String']['input'];
};


export type MutationUpdateProductArgs = {
  account_id: Scalars['String']['input'];
  input: ProductInput;
  store_id: Scalars['String']['input'];
};


export type MutationUpdatePromotionArgs = {
  account_id: Scalars['String']['input'];
  input: PromotionInput;
  store_id: Scalars['String']['input'];
};


export type MutationUpdateRedirectAppArgs = {
  account_id: Scalars['String']['input'];
  input: RedirectInput;
  store_id: Scalars['String']['input'];
};


export type MutationUpdateReverseProxyAppArgs = {
  account_id: Scalars['String']['input'];
  input: ReverseProxyInput;
  store_id: Scalars['String']['input'];
};


export type MutationUpdateStoreArgs = {
  account_id: Scalars['String']['input'];
  input: StoreInput;
};


export type MutationUpdateStoreNotificationSettingArgs = {
  account_id: Scalars['String']['input'];
  input: NotificationSettingInput;
  store_id: Scalars['String']['input'];
};


export type MutationUpdateStrongholdAppArgs = {
  account_id: Scalars['String']['input'];
  input: StrongholdInput;
  store_id: Scalars['String']['input'];
};


export type MutationUpdateStrongholdChargeIdArgs = {
  account_id: Scalars['String']['input'];
  char_id: Scalars['String']['input'];
  order_id: Scalars['String']['input'];
  store_id: Scalars['String']['input'];
};


export type MutationUpdateSurfsideAppArgs = {
  account_id: Scalars['String']['input'];
  input: SurfsideInput;
  store_id: Scalars['String']['input'];
};


export type MutationUpdateSwifterAppArgs = {
  account_id: Scalars['String']['input'];
  input: SwifterInput;
  store_id: Scalars['String']['input'];
};


export type MutationUpdateTagArgs = {
  account_id: Scalars['String']['input'];
  input: TagInput;
  store_id: Scalars['String']['input'];
};


export type MutationUpdateTreezAppArgs = {
  account_id: Scalars['String']['input'];
  input: TreezInput;
  store_id: Scalars['String']['input'];
};


export type MutationUpdateTreezCartArgs = {
  account_id: Scalars['String']['input'];
  create_draft_ticket?: InputMaybe<Scalars['Boolean']['input']>;
  input: UpdateCartInput;
  store_id: Scalars['String']['input'];
};


export type MutationUpdateTreezPayAppArgs = {
  account_id: Scalars['String']['input'];
  input: TreezPayInput;
  store_id: Scalars['String']['input'];
};


export type MutationUpdateUserArgs = {
  input: UserInput;
};


export type MutationUploadAccountPhotoArgs = {
  account_id: Scalars['String']['input'];
  input: AccountUploadPhotoInput;
  store_id: Scalars['String']['input'];
};


export type MutationUploadFileArgs = {
  input: FileUploadInput;
};

export type Navigation = {
  __typename?: 'Navigation';
  id?: Maybe<Scalars['String']['output']>;
  menu_items?: Maybe<Array<Maybe<MenuItem>>>;
  slug?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type NavigationInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  menu_items?: InputMaybe<Array<InputMaybe<MenuItemInput>>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationSetting = {
  __typename?: 'NotificationSetting';
  content?: Maybe<Scalars['String']['output']>;
  email_subject?: Maybe<Scalars['String']['output']>;
  handler?: Maybe<Scalars['String']['output']>;
  notification_active?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<NotificationType>;
};

export type NotificationSettingInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  email_subject?: InputMaybe<Scalars['String']['input']>;
  handler?: InputMaybe<Scalars['String']['input']>;
  notification_active?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<NotificationType>;
};

export enum NotificationType {
  Email = 'EMAIL',
  Sms = 'SMS'
}

export type Omnisend = App & Crm & {
  __typename?: 'Omnisend';
  api_key?: Maybe<Scalars['String']['output']>;
  category: AppCategoryType;
  created_at?: Maybe<Scalars['TimeStamp']['output']>;
  handler: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  status?: Maybe<Scalars['Boolean']['output']>;
  type: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['TimeStamp']['output']>;
  used_for_subscription?: Maybe<Scalars['Boolean']['output']>;
};

export type OmnisendInput = {
  api_key?: InputMaybe<Scalars['String']['input']>;
  category: AppCategoryType;
  created_at?: InputMaybe<Scalars['TimeStamp']['input']>;
  handler: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  status?: InputMaybe<Scalars['Boolean']['input']>;
  type: Scalars['String']['input'];
  updated_at?: InputMaybe<Scalars['TimeStamp']['input']>;
  used_for_subscription?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OnFleet = App & {
  __typename?: 'OnFleet';
  auto_assign?: Maybe<Scalars['Boolean']['output']>;
  auto_assign_mode?: Maybe<OnFleetAutoAssignType>;
  category: AppCategoryType;
  created_at?: Maybe<Scalars['TimeStamp']['output']>;
  handler: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  merchants?: Maybe<Array<OnFleetMerchants>>;
  name: Scalars['String']['output'];
  sandbox?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
  test_user?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['TimeStamp']['output']>;
  user?: Maybe<Scalars['String']['output']>;
};

export enum OnFleetAutoAssignType {
  Distance = 'DISTANCE',
  Load = 'LOAD'
}

export type OnFleetDelivery = {
  __typename?: 'OnFleetDelivery';
  complete_after?: Maybe<Scalars['TimeStamp']['output']>;
  complete_before?: Maybe<Scalars['TimeStamp']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  status?: Maybe<DeliveryStatus>;
  tracking_url?: Maybe<Scalars['String']['output']>;
  worker_id?: Maybe<Scalars['String']['output']>;
  worker_image?: Maybe<Scalars['String']['output']>;
  worker_name?: Maybe<Scalars['String']['output']>;
};

export type OnFleetDeliveryInput = {
  complete_after?: InputMaybe<Scalars['TimeStamp']['input']>;
  complete_before?: InputMaybe<Scalars['TimeStamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<DeliveryStatus>;
  tracking_url?: InputMaybe<Scalars['String']['input']>;
  worker_id?: InputMaybe<Scalars['String']['input']>;
  worker_image?: InputMaybe<Scalars['String']['input']>;
  worker_name?: InputMaybe<Scalars['String']['input']>;
};

export type OnFleetInput = {
  auto_assign?: InputMaybe<Scalars['Boolean']['input']>;
  auto_assign_mode?: InputMaybe<OnFleetAutoAssignType>;
  category: AppCategoryType;
  created_at?: InputMaybe<Scalars['TimeStamp']['input']>;
  handler: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  merchants?: InputMaybe<Array<OnFleetMerchantsInput>>;
  name: Scalars['String']['input'];
  sandbox?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  test_user?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  updated_at?: InputMaybe<Scalars['TimeStamp']['input']>;
  user?: InputMaybe<Scalars['String']['input']>;
};

export type OnFleetMerchants = {
  __typename?: 'OnFleetMerchants';
  merchant: Scalars['String']['output'];
  store_id: Scalars['String']['output'];
};

export type OnFleetMerchantsInput = {
  merchant: Scalars['String']['input'];
  store_id: Scalars['String']['input'];
};

export type Option = {
  __typename?: 'Option';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  sort?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type OptionFilterInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['Int']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type OptionInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  sort: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type Order = {
  __typename?: 'Order';
  activity_logs?: Array<ActivityLog>;
  allow_custom_delivery_fee?: Maybe<Scalars['Boolean']['output']>;
  alpineiq_redemption_id?: Maybe<Scalars['String']['output']>;
  alpineiq_redemption_url?: Maybe<Scalars['String']['output']>;
  alpineiq_template_id?: Maybe<Scalars['String']['output']>;
  blaze_cart_id?: Maybe<Scalars['String']['output']>;
  buyer_accepts_marketing?: Maybe<Scalars['Boolean']['output']>;
  client_detail?: Maybe<ClientDetail>;
  created_at?: Maybe<Scalars['TimeStamp']['output']>;
  date_of_birth?: Maybe<Scalars['TimeStamp']['output']>;
  declined_from_admin?: Maybe<Scalars['Boolean']['output']>;
  delivery_address?: Maybe<OrderAddress>;
  delivery_details?: Maybe<OrderDelivery>;
  discount_items?: Maybe<Array<Maybe<OrderDiscountItem>>>;
  dutchie_order_id?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  entity_id?: Maybe<Scalars['String']['output']>;
  error_reason?: Maybe<Scalars['String']['output']>;
  invoice_date?: Maybe<Scalars['TimeStamp']['output']>;
  jane_cart_id?: Maybe<Scalars['String']['output']>;
  jane_order_id?: Maybe<Scalars['String']['output']>;
  /** @deprecated use provider_store_full_address */
  jane_store_full_address?: Maybe<Scalars['String']['output']>;
  /** @deprecated use provider_store_id */
  jane_store_id?: Maybe<Scalars['String']['output']>;
  /** @deprecated use provider_store_name */
  jane_store_name?: Maybe<Scalars['String']['output']>;
  /** @deprecated use provider_store_phone_number */
  jane_store_phone_number?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  line_items?: Maybe<Array<Maybe<LineItem>>>;
  notes?: Maybe<Scalars['String']['output']>;
  order_medical_id?: Maybe<Scalars['String']['output']>;
  order_medical_id_expiration_date?: Maybe<Scalars['TimeStamp']['output']>;
  order_number?: Maybe<Scalars['Int']['output']>;
  order_type?: Maybe<AccountType>;
  payment_details?: Maybe<PaymentDetail>;
  provider_store_full_address?: Maybe<Scalars['String']['output']>;
  provider_store_id?: Maybe<Scalars['String']['output']>;
  provider_store_name?: Maybe<Scalars['String']['output']>;
  provider_store_phone_number?: Maybe<Scalars['String']['output']>;
  retry?: Maybe<Scalars['Int']['output']>;
  state_of_residence?: Maybe<Scalars['String']['output']>;
  status?: Maybe<OrderStatusType>;
  subtotal_price?: Maybe<Scalars['Int']['output']>;
  total_delivery?: Maybe<Scalars['Int']['output']>;
  total_discounts?: Maybe<Scalars['Int']['output']>;
  total_line_items_price?: Maybe<Scalars['Int']['output']>;
  total_price?: Maybe<Scalars['Int']['output']>;
  total_service_fee?: Maybe<Scalars['Int']['output']>;
  total_tax?: Maybe<Scalars['Int']['output']>;
  treez_order_id?: Maybe<Scalars['String']['output']>;
  treez_order_number?: Maybe<Scalars['String']['output']>;
  treez_pay_ticket_ids_by_store?: Maybe<Array<Maybe<TreezPayTicket>>>;
  updated_at?: Maybe<Scalars['TimeStamp']['output']>;
};

export type OrderAddress = {
  __typename?: 'OrderAddress';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  city_code?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  province?: Maybe<Scalars['String']['output']>;
  province_code?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type OrderAddressInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  city_code?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  country_code?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
  province_code?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type OrderConnection = {
  __typename?: 'OrderConnection';
  edges?: Maybe<Array<Maybe<OrderEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type OrderCursorPagination = {
  __typename?: 'OrderCursorPagination';
  cursor?: Maybe<Scalars['String']['output']>;
  orders?: Maybe<Array<Maybe<Order>>>;
};

export type OrderDelivery = {
  __typename?: 'OrderDelivery';
  curbside_pickup?: Maybe<Scalars['Boolean']['output']>;
  curbside_pickup_note?: Maybe<Scalars['String']['output']>;
  deliver_after?: Maybe<Scalars['TimeStamp']['output']>;
  deliver_before?: Maybe<Scalars['TimeStamp']['output']>;
  delivery?: Maybe<Scalars['Boolean']['output']>;
  finished_at?: Maybe<Scalars['TimeStamp']['output']>;
  on_fleet?: Maybe<OnFleetDelivery>;
  pickup?: Maybe<Scalars['Boolean']['output']>;
  started_at?: Maybe<Scalars['TimeStamp']['output']>;
  time_window?: Maybe<Scalars['String']['output']>;
};

export type OrderDeliveryInput = {
  curbside_pickup?: InputMaybe<Scalars['Boolean']['input']>;
  curbside_pickup_note?: InputMaybe<Scalars['String']['input']>;
  deliver_after?: InputMaybe<Scalars['TimeStamp']['input']>;
  deliver_before?: InputMaybe<Scalars['TimeStamp']['input']>;
  delivery?: InputMaybe<Scalars['Boolean']['input']>;
  finished_at?: InputMaybe<Scalars['TimeStamp']['input']>;
  on_fleet?: InputMaybe<OnFleetDeliveryInput>;
  pickup?: InputMaybe<Scalars['Boolean']['input']>;
  started_at?: InputMaybe<Scalars['TimeStamp']['input']>;
  time_window?: InputMaybe<Scalars['String']['input']>;
};

export type OrderDiscountItem = {
  __typename?: 'OrderDiscountItem';
  blaze_id?: Maybe<Scalars['String']['output']>;
  discountType?: Maybe<DiscountType>;
  discount_apply_type?: Maybe<DiscountApplyType>;
  discount_rate_type?: Maybe<DiscountRateType>;
  id?: Maybe<Scalars['String']['output']>;
  promo_code?: Maybe<Scalars['String']['output']>;
  rate?: Maybe<Scalars['Int']['output']>;
};

export type OrderDiscountItemInput = {
  blaze_id?: InputMaybe<Scalars['String']['input']>;
  discountType: DiscountType;
  discount_apply_type?: InputMaybe<DiscountApplyType>;
  discount_rate_type: DiscountRateType;
  id: Scalars['String']['input'];
  promo_code?: InputMaybe<Scalars['String']['input']>;
  rate: Scalars['Int']['input'];
};

export type OrderEdge = {
  __typename?: 'OrderEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node: Order;
};

export type OrderFilter = {
  customer?: InputMaybe<CustomerOrderFilter>;
};

export type OrderInput = {
  allow_custom_delivery_fee?: InputMaybe<Scalars['Boolean']['input']>;
  alpineiq_redemption_id?: InputMaybe<Scalars['String']['input']>;
  alpineiq_redemption_url?: InputMaybe<Scalars['String']['input']>;
  alpineiq_template_id?: InputMaybe<Scalars['String']['input']>;
  buyer_accepts_marketing?: InputMaybe<Scalars['Boolean']['input']>;
  date_of_birth?: InputMaybe<Scalars['TimeStamp']['input']>;
  delivery_address?: InputMaybe<OrderAddressInput>;
  delivery_details?: InputMaybe<OrderDeliveryInput>;
  discount_items?: InputMaybe<Array<InputMaybe<OrderDiscountItemInput>>>;
  dutchie_order_id?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  entity_id?: InputMaybe<Scalars['String']['input']>;
  jane_cart_id?: InputMaybe<Scalars['String']['input']>;
  jane_order_id?: InputMaybe<Scalars['String']['input']>;
  jane_store_full_address?: InputMaybe<Scalars['String']['input']>;
  jane_store_id?: InputMaybe<Scalars['String']['input']>;
  jane_store_name?: InputMaybe<Scalars['String']['input']>;
  jane_store_phone_number?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  line_items?: InputMaybe<Array<InputMaybe<LineItemInput>>>;
  notes?: InputMaybe<Scalars['String']['input']>;
  order_medical_id?: InputMaybe<Scalars['String']['input']>;
  order_medical_id_expiration_date?: InputMaybe<Scalars['TimeStamp']['input']>;
  order_type?: InputMaybe<AccountType>;
  payment_details?: InputMaybe<PaymentDetailInput>;
  provider_store_full_address?: InputMaybe<Scalars['String']['input']>;
  provider_store_id?: InputMaybe<Scalars['String']['input']>;
  provider_store_name?: InputMaybe<Scalars['String']['input']>;
  provider_store_phone_number?: InputMaybe<Scalars['String']['input']>;
  state_of_residence?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<OrderStatusType>;
  subtotal_price?: InputMaybe<Scalars['Int']['input']>;
  total_delivery?: InputMaybe<Scalars['Int']['input']>;
  total_discounts?: InputMaybe<Scalars['Int']['input']>;
  total_line_items_price?: InputMaybe<Scalars['Int']['input']>;
  total_price?: InputMaybe<Scalars['Int']['input']>;
  total_service_fee?: InputMaybe<Scalars['Int']['input']>;
  total_tax?: InputMaybe<Scalars['Int']['input']>;
  treez_order_id?: InputMaybe<Scalars['String']['input']>;
  treez_order_number?: InputMaybe<Scalars['String']['input']>;
  treez_pay_ticket_ids_by_store?: InputMaybe<Array<InputMaybe<TreezPayTicketInput>>>;
};

export enum OrderStatusType {
  AbandonedCart = 'ABANDONED_CART',
  Approved = 'APPROVED',
  Assigned = 'ASSIGNED',
  Declined = 'DECLINED',
  Delivered = 'DELIVERED',
  DeliveryFinished = 'DELIVERY_FINISHED',
  DeliveryStarted = 'DELIVERY_STARTED',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  Ready = 'READY',
  Refunded = 'REFUNDED',
  Void = 'VOID'
}

export type Page = {
  __typename?: 'Page';
  created_at?: Maybe<Scalars['TimeStamp']['output']>;
  html_body?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<Scalars['String']['output']>;
  publish_at?: Maybe<Scalars['TimeStamp']['output']>;
  seo?: Maybe<Seo>;
  slug?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
  template?: Maybe<Template>;
  updated_at?: Maybe<Scalars['TimeStamp']['output']>;
};

export type PageConnection = {
  __typename?: 'PageConnection';
  edges?: Maybe<Array<Maybe<PageEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PageEdge = {
  __typename?: 'PageEdge';
  cursor: Scalars['String']['output'];
  node: Page;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
};

export type PageInput = {
  created_at?: InputMaybe<Scalars['TimeStamp']['input']>;
  html_body?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['String']['input']>;
  publish_at?: InputMaybe<Scalars['TimeStamp']['input']>;
  seo?: InputMaybe<SeoInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  template?: InputMaybe<Template>;
  updated_at?: InputMaybe<Scalars['TimeStamp']['input']>;
};

export type PaymentDetail = {
  __typename?: 'PaymentDetail';
  aeropay_detail?: Maybe<AeroPayPaymentDetail>;
  card_type?: Maybe<Scalars['String']['output']>;
  last_four?: Maybe<Scalars['String']['output']>;
  refund_id?: Maybe<Scalars['String']['output']>;
  refunded?: Maybe<Scalars['Boolean']['output']>;
  stronghold_detail?: Maybe<StrongholdPaymentDetail>;
  swifter_detail?: Maybe<SwifterPaymentDetail>;
  treezpay_detail?: Maybe<TreezPayPaymentDetail>;
  type?: Maybe<PaymentType>;
};

export type PaymentDetailInput = {
  aeropay_detail?: InputMaybe<AeroPayPaymentDetailInput>;
  card_type?: InputMaybe<Scalars['String']['input']>;
  last_four?: InputMaybe<Scalars['String']['input']>;
  refund_id?: InputMaybe<Scalars['String']['input']>;
  refunded?: InputMaybe<Scalars['Boolean']['input']>;
  treezpay_detail?: InputMaybe<TreezPayPaymentDetailInput>;
  type?: InputMaybe<PaymentType>;
};

export enum PaymentType {
  Aeropay = 'AEROPAY',
  Cash = 'CASH',
  Check = 'CHECK',
  CreditCard = 'CREDIT_CARD',
  DebitCard = 'DEBIT_CARD',
  Stronghold = 'STRONGHOLD',
  Swifter = 'SWIFTER',
  Treezpay = 'TREEZPAY'
}

export type PickupScheduleZone = {
  __typename?: 'PickupScheduleZone';
  name?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  stores_provider_id: Scalars['String']['output'];
  time_slots?: Maybe<Array<Maybe<TimeSlot>>>;
  working_hours?: Maybe<Array<Maybe<ScheduleWorkingHours>>>;
};

export type PickupScheduleZoneInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  stores_provider_id: Scalars['String']['input'];
  time_slots?: InputMaybe<Array<InputMaybe<TimeSlotInput>>>;
  working_hours?: InputMaybe<Array<InputMaybe<ScheduleWorkingHoursInput>>>;
};

export type PriceRange = {
  __typename?: 'PriceRange';
  assigned_price?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
  sale_price?: Maybe<Scalars['Int']['output']>;
};

export type PriceRangeInput = {
  assigned_price?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  sale_price?: InputMaybe<Scalars['Int']['input']>;
};

export enum PriceType {
  Flat = 'FLAT',
  Tier = 'TIER'
}

export type Product = {
  __typename?: 'Product';
  amount?: Maybe<Scalars['String']['output']>;
  asset?: Maybe<Asset>;
  assets?: Maybe<Array<Asset>>;
  available_for_delivery?: Maybe<Scalars['Boolean']['output']>;
  available_for_pickup?: Maybe<Scalars['Boolean']['output']>;
  barcodes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  best_seller?: Maybe<Scalars['Boolean']['output']>;
  brand_id?: Maybe<Scalars['String']['output']>;
  brand_name?: Maybe<Scalars['String']['output']>;
  brand_subtype?: Maybe<Scalars['String']['output']>;
  cannabis_type?: Maybe<CannabisType>;
  category?: Maybe<Scalars['String']['output']>;
  category_id?: Maybe<Scalars['String']['output']>;
  cbd?: Maybe<Component>;
  cbda?: Maybe<Component>;
  created_at?: Maybe<Scalars['TimeStamp']['output']>;
  custom_tax?: Maybe<TaxInfo>;
  description?: Maybe<Scalars['String']['output']>;
  discount_enabled?: Maybe<Scalars['Boolean']['output']>;
  dosage?: Maybe<Scalars['String']['output']>;
  effects?: Maybe<Array<Scalars['String']['output']>>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  enterpriseProductId?: Maybe<Scalars['String']['output']>;
  flavors?: Maybe<Array<Scalars['String']['output']>>;
  flower_type?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  in_stock?: Maybe<Scalars['Boolean']['output']>;
  ingridients?: Maybe<Array<Scalars['String']['output']>>;
  max_cart_quantity?: Maybe<Scalars['Int']['output']>;
  medical_conditions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  medicinal?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  new?: Maybe<Scalars['Boolean']['output']>;
  price_range?: Maybe<Array<Maybe<PriceRange>>>;
  price_type?: Maybe<PriceType>;
  product_sale_type?: Maybe<ProductSaleType>;
  product_type?: Maybe<ProductType>;
  qty?: Maybe<Scalars['Int']['output']>;
  related_products?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  review_rating?: Maybe<Scalars['Float']['output']>;
  reviews?: Maybe<Scalars['Int']['output']>;
  sales_price?: Maybe<Scalars['Int']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  special_amount?: Maybe<Scalars['String']['output']>;
  special_id?: Maybe<Scalars['String']['output']>;
  special_title?: Maybe<Scalars['String']['output']>;
  subcategory?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  tax_tables?: Maybe<Array<Maybe<TaxTable>>>;
  thc?: Maybe<Component>;
  thca?: Maybe<Component>;
  unit_price?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['TimeStamp']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  usable_marijuana?: Maybe<Scalars['Int']['output']>;
  variants?: Maybe<Array<Maybe<Variant>>>;
  vendors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ProductConnection = {
  __typename?: 'ProductConnection';
  edges?: Maybe<Array<Maybe<ProductEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ProductEdge = {
  __typename?: 'ProductEdge';
  cursor: Scalars['String']['output'];
  node: Product;
};

export type ProductInput = {
  asset?: InputMaybe<AssetInput>;
  available_for_delivery?: InputMaybe<Scalars['Boolean']['input']>;
  available_for_pickup?: InputMaybe<Scalars['Boolean']['input']>;
  barcodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  best_seller?: InputMaybe<Scalars['Boolean']['input']>;
  brand_id?: InputMaybe<Scalars['String']['input']>;
  brand_name?: InputMaybe<Scalars['String']['input']>;
  cannabis_type?: InputMaybe<CannabisType>;
  category?: InputMaybe<Scalars['String']['input']>;
  category_id?: InputMaybe<Scalars['String']['input']>;
  cbd?: InputMaybe<ComponentInput>;
  cbda?: InputMaybe<ComponentInput>;
  created_at?: InputMaybe<Scalars['TimeStamp']['input']>;
  custom_tax?: InputMaybe<TaxInfoInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  discount_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  effects?: InputMaybe<Array<Scalars['String']['input']>>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  flavors?: InputMaybe<Array<Scalars['String']['input']>>;
  flower_type?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  in_stock?: InputMaybe<Scalars['Boolean']['input']>;
  ingridients?: InputMaybe<Array<Scalars['String']['input']>>;
  max_cart_quantity?: InputMaybe<Scalars['Int']['input']>;
  medical_conditions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  medicinal?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  new?: InputMaybe<Scalars['Boolean']['input']>;
  price_range?: InputMaybe<Array<InputMaybe<PriceRangeInput>>>;
  product_sale_type?: InputMaybe<ProductSaleType>;
  product_type?: InputMaybe<ProductType>;
  qty?: InputMaybe<Scalars['Int']['input']>;
  related_products?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  review_rating?: InputMaybe<Scalars['Float']['input']>;
  reviews?: InputMaybe<Scalars['Int']['input']>;
  sales_price?: InputMaybe<Scalars['Int']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tax_tables?: InputMaybe<Array<InputMaybe<TaxTableInput>>>;
  thc?: InputMaybe<ComponentInput>;
  thca?: InputMaybe<ComponentInput>;
  unit_price?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['TimeStamp']['input']>;
  usable_marijuana?: InputMaybe<Scalars['Int']['input']>;
  variants?: InputMaybe<Array<InputMaybe<VariantInput>>>;
  vendors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export enum ProductSaleType {
  Both = 'Both',
  Medicinal = 'Medicinal',
  Recreational = 'Recreational'
}

export enum ProductSortKeys {
  CreateAt = 'CREATE_AT',
  Id = 'ID'
}

export enum ProductType {
  Bundle = 'BUNDLE',
  Derived = 'DERIVED',
  Regular = 'REGULAR'
}

export type Promotion = {
  __typename?: 'Promotion';
  blaze_id?: Maybe<Scalars['String']['output']>;
  broadcast?: Maybe<Scalars['Boolean']['output']>;
  broadcast_color?: Maybe<Scalars['String']['output']>;
  broadcast_type?: Maybe<BroadcastType>;
  discountType?: Maybe<DiscountType>;
  discount_apply_type?: Maybe<DiscountApplyType>;
  discount_rate_type?: Maybe<DiscountRateType>;
  enabled_friday?: Maybe<Scalars['Boolean']['output']>;
  enabled_monday?: Maybe<Scalars['Boolean']['output']>;
  enabled_saturday?: Maybe<Scalars['Boolean']['output']>;
  enabled_sunday?: Maybe<Scalars['Boolean']['output']>;
  enabled_thursday?: Maybe<Scalars['Boolean']['output']>;
  enabled_tuesday?: Maybe<Scalars['Boolean']['output']>;
  enabled_wednesday?: Maybe<Scalars['Boolean']['output']>;
  expiration_date?: Maybe<Scalars['TimeStamp']['output']>;
  first_time_patient?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  maximum_order_amount?: Maybe<Scalars['Int']['output']>;
  maximum_order_required?: Maybe<Scalars['Boolean']['output']>;
  minimum_order_amount?: Maybe<Scalars['Int']['output']>;
  minimum_order_required?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  never_expire?: Maybe<Scalars['Boolean']['output']>;
  photo?: Maybe<Asset>;
  priority?: Maybe<Scalars['Int']['output']>;
  products_id?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  promo_code?: Maybe<Scalars['String']['output']>;
  promo_code_max_number_of_uses?: Maybe<Scalars['Int']['output']>;
  rate?: Maybe<Scalars['Int']['output']>;
  start_date?: Maybe<Scalars['TimeStamp']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type PromotionInput = {
  blaze_id?: InputMaybe<Scalars['String']['input']>;
  broadcast?: InputMaybe<Scalars['Boolean']['input']>;
  broadcast_color?: InputMaybe<Scalars['String']['input']>;
  broadcast_type?: InputMaybe<BroadcastType>;
  discountType?: InputMaybe<DiscountType>;
  discount_apply_type?: InputMaybe<DiscountApplyType>;
  discount_rate_type?: InputMaybe<DiscountRateType>;
  enabled_friday?: InputMaybe<Scalars['Boolean']['input']>;
  enabled_monday?: InputMaybe<Scalars['Boolean']['input']>;
  enabled_saturday?: InputMaybe<Scalars['Boolean']['input']>;
  enabled_sunday?: InputMaybe<Scalars['Boolean']['input']>;
  enabled_thursday?: InputMaybe<Scalars['Boolean']['input']>;
  enabled_tuesday?: InputMaybe<Scalars['Boolean']['input']>;
  enabled_wednesday?: InputMaybe<Scalars['Boolean']['input']>;
  expiration_date?: InputMaybe<Scalars['TimeStamp']['input']>;
  first_time_patient?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  maximum_order_amount?: InputMaybe<Scalars['Int']['input']>;
  maximum_order_required?: InputMaybe<Scalars['Boolean']['input']>;
  minimum_order_amount?: InputMaybe<Scalars['Int']['input']>;
  minimum_order_required?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  never_expire?: InputMaybe<Scalars['Boolean']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  products_id?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  promo_code?: InputMaybe<Scalars['String']['input']>;
  promo_code_max_number_of_uses?: InputMaybe<Scalars['Int']['input']>;
  rate?: InputMaybe<Scalars['Int']['input']>;
  start_date?: InputMaybe<Scalars['TimeStamp']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PromotionItem = {
  __typename?: 'PromotionItem';
  id?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ProviderStore = {
  id: Scalars['String']['input'];
  provider: ProviderStoreType;
};

export enum ProviderStoreType {
  Treez = 'TREEZ'
}

export type Query = {
  __typename?: 'Query';
  allBusinessAccounts?: Maybe<Array<Maybe<BusinessAccount>>>;
  allStores?: Maybe<Array<Maybe<Store>>>;
  checkDeploymentStatus?: Maybe<DeploymentStatus>;
  customerOrderHistory?: Maybe<OrderCursorPagination>;
  getAccount?: Maybe<Account>;
  getAccountByEmail?: Maybe<Account>;
  getAccountPhoto?: Maybe<Scalars['String']['output']>;
  getActivePromotion?: Maybe<Promotion>;
  getAllReviews?: Maybe<Array<Maybe<Review>>>;
  getApp?: Maybe<App>;
  getBerbixTransactionResult?: Maybe<BerbixTransactionResult>;
  getBestSellingProducts?: Maybe<Array<Maybe<BestSellingProduct>>>;
  getBrand?: Maybe<Brand>;
  getBusinessAccount?: Maybe<BusinessAccount>;
  getCategory?: Maybe<Category>;
  getDeliveryETA?: Maybe<Array<Maybe<DeliveryEta>>>;
  getDistance: Array<Distance>;
  getIDPAccount?: Maybe<IdpAccount>;
  getJaneBestBundlePosibility?: Maybe<JaneBestProductBundlePosibility>;
  getLanding?: Maybe<Landing>;
  getNavigation?: Maybe<Navigation>;
  getNotificationSetting?: Maybe<NotificationSetting>;
  getOption?: Maybe<Option>;
  getOrder?: Maybe<Order>;
  getOrderDeliveryETA?: Maybe<Scalars['Int']['output']>;
  getPage?: Maybe<Page>;
  getPageByPath?: Maybe<Page>;
  getPageBySlug?: Maybe<Page>;
  getPageByTemplate?: Maybe<Page>;
  getProduct?: Maybe<Product>;
  getProductByPath?: Maybe<Product>;
  getProductFromJane?: Maybe<Product>;
  getProductReviewFromFeefo?: Maybe<FeefoProductReviews>;
  getProductReviewFromJane?: Maybe<Array<Maybe<JaneProductReview>>>;
  getPromotion?: Maybe<Promotion>;
  getReview?: Maybe<Review>;
  getSnapshot?: Maybe<StatSnapShot>;
  getStats?: Maybe<Stats>;
  getStore?: Maybe<Store>;
  getStoreApp?: Maybe<App>;
  getStoreMenu?: Maybe<Array<Maybe<StoreMenu>>>;
  getStoreNotificationSetting?: Maybe<NotificationSetting>;
  getTag?: Maybe<Tag>;
  getTreezHeadlessConfig: TreezHeadlessConfig;
  getTreezHeadlessDiscounts?: Maybe<Array<TreezHeadlessDiscount>>;
  getTreezHeadlessGroups?: Maybe<Array<TreezHeadlessGroup>>;
  getTreezPayToken?: Maybe<Scalars['String']['output']>;
  getUser?: Maybe<User>;
  getVendor?: Maybe<Vendor>;
  healthcheck?: Maybe<HealthCheck>;
  listAccounts?: Maybe<AccountCursorPagination>;
  listActivePromotions?: Maybe<Array<Maybe<Promotion>>>;
  listApps?: Maybe<Array<Maybe<App>>>;
  listBrands?: Maybe<Array<Maybe<Brand>>>;
  listCategory?: Maybe<Array<Maybe<Category>>>;
  listHubs?: Maybe<Array<Maybe<DeliveryHub>>>;
  listInventories?: Maybe<Array<Maybe<BlazeProductInventory>>>;
  listJaneSpecials?: Maybe<Array<Maybe<JaneSpecial>>>;
  listJaneStores?: Maybe<Array<Maybe<JaneStore>>>;
  listLandings?: Maybe<Array<Maybe<Landing>>>;
  listNavigations?: Maybe<Array<Maybe<Navigation>>>;
  listNotificationSettings?: Maybe<Array<Maybe<NotificationSetting>>>;
  listOptions?: Maybe<Array<Maybe<Option>>>;
  listPages?: Maybe<Array<Maybe<Page>>>;
  listPagesByTemplate?: Maybe<PageConnection>;
  listProducts?: Maybe<Array<Maybe<Product>>>;
  listPromotions?: Maybe<Array<Maybe<Promotion>>>;
  listStoreApps?: Maybe<Array<Maybe<App>>>;
  listStoreNotificationSettings?: Maybe<Array<Maybe<NotificationSetting>>>;
  listStoreOrders?: Maybe<OrderConnection>;
  listStoresFromAccount?: Maybe<Array<Maybe<Store>>>;
  listTag?: Maybe<Array<Maybe<Tag>>>;
  listTerminalInventory?: Maybe<Array<Maybe<BlazeTerminalInventory>>>;
  listUsers?: Maybe<Array<Maybe<User>>>;
  listVendors?: Maybe<Array<Maybe<Vendor>>>;
  listWorkersInLocation?: Maybe<Array<Maybe<DeliveryWorker>>>;
  searchProduct?: Maybe<ProductConnection>;
  searchTreezHeadlessProducts?: Maybe<Array<Product>>;
  verifyContactAlpineIQ?: Maybe<Scalars['Boolean']['output']>;
  viewContactWalletAlpineIQ?: Maybe<ContactWallet>;
};


export type QueryCheckDeploymentStatusArgs = {
  account_id: Scalars['String']['input'];
  store_id: Scalars['String']['input'];
};


export type QueryCustomerOrderHistoryArgs = {
  account_id: Scalars['String']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  store_id: Scalars['String']['input'];
  total_price?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetAccountArgs = {
  account_id: Scalars['String']['input'];
  id: Scalars['String']['input'];
  store_id: Scalars['String']['input'];
};


export type QueryGetAccountByEmailArgs = {
  account_id: Scalars['String']['input'];
  email: Scalars['String']['input'];
  provider_store?: InputMaybe<ProviderStore>;
  store_id: Scalars['String']['input'];
};


export type QueryGetAccountPhotoArgs = {
  filename: Scalars['String']['input'];
};


export type QueryGetActivePromotionArgs = {
  account_id: Scalars['String']['input'];
  promotion_id: Scalars['String']['input'];
  store_id: Scalars['String']['input'];
};


export type QueryGetAppArgs = {
  app_id: Scalars['String']['input'];
};


export type QueryGetBerbixTransactionResultArgs = {
  access_token: Scalars['String']['input'];
  account_id: Scalars['String']['input'];
  refresh_token: Scalars['String']['input'];
  store_id: Scalars['String']['input'];
};


export type QueryGetBestSellingProductsArgs = {
  account_id: Scalars['String']['input'];
  count?: InputMaybe<Scalars['Int']['input']>;
  store_id: Scalars['String']['input'];
};


export type QueryGetBrandArgs = {
  account_id: Scalars['String']['input'];
  brand_id: Scalars['String']['input'];
  store_id: Scalars['String']['input'];
};


export type QueryGetBusinessAccountArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetCategoryArgs = {
  account_id: Scalars['String']['input'];
  category_id: Scalars['String']['input'];
  store_id: Scalars['String']['input'];
};


export type QueryGetDeliveryEtaArgs = {
  account_id: Scalars['String']['input'];
  location: Array<InputMaybe<Scalars['Float']['input']>>;
  not_included_vehicles?: InputMaybe<Array<InputMaybe<DeliveryVehicleType>>>;
  store_id: Scalars['String']['input'];
};


export type QueryGetDistanceArgs = {
  from: Coordinates;
  to: Coordinates;
};


export type QueryGetIdpAccountArgs = {
  account_id: Scalars['String']['input'];
  email: Scalars['String']['input'];
  store_id: Scalars['String']['input'];
};


export type QueryGetJaneBestBundlePosibilityArgs = {
  account_id: Scalars['String']['input'];
  input: Array<JaneBestProductBundlePosibilityInput>;
  store_id: Scalars['String']['input'];
};


export type QueryGetLandingArgs = {
  account_id: Scalars['String']['input'];
  landing_id: Scalars['String']['input'];
  store_id: Scalars['String']['input'];
};


export type QueryGetNavigationArgs = {
  account_id: Scalars['String']['input'];
  navigation_id: Scalars['String']['input'];
  store_id: Scalars['String']['input'];
};


export type QueryGetNotificationSettingArgs = {
  handler: Scalars['String']['input'];
};


export type QueryGetOptionArgs = {
  account_id: Scalars['String']['input'];
  option_id: Scalars['String']['input'];
  store_id: Scalars['String']['input'];
};


export type QueryGetOrderArgs = {
  account_id: Scalars['String']['input'];
  entity_id: Scalars['String']['input'];
  store_id: Scalars['String']['input'];
};


export type QueryGetOrderDeliveryEtaArgs = {
  account_id: Scalars['String']['input'];
  entity_id: Scalars['String']['input'];
  store_id: Scalars['String']['input'];
};


export type QueryGetPageArgs = {
  account_id: Scalars['String']['input'];
  page_id: Scalars['String']['input'];
  store_id: Scalars['String']['input'];
};


export type QueryGetPageByPathArgs = {
  account_id: Scalars['String']['input'];
  path: Scalars['String']['input'];
  store_id: Scalars['String']['input'];
};


export type QueryGetPageBySlugArgs = {
  account_id: Scalars['String']['input'];
  slug: Scalars['String']['input'];
  store_id: Scalars['String']['input'];
};


export type QueryGetPageByTemplateArgs = {
  account_id: Scalars['String']['input'];
  store_id: Scalars['String']['input'];
  template: Template;
};


export type QueryGetProductArgs = {
  account_id: Scalars['String']['input'];
  product_id: Scalars['String']['input'];
  provider_store_id?: InputMaybe<Scalars['String']['input']>;
  store_id: Scalars['String']['input'];
};


export type QueryGetProductByPathArgs = {
  account_id: Scalars['String']['input'];
  path: Scalars['String']['input'];
  store_id: Scalars['String']['input'];
};


export type QueryGetProductFromJaneArgs = {
  account_id: Scalars['String']['input'];
  product_id: Scalars['String']['input'];
  store_id: Scalars['String']['input'];
  stores: Array<Scalars['String']['input']>;
};


export type QueryGetProductReviewFromFeefoArgs = {
  account_id: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  product_sku: Scalars['String']['input'];
  store_id: Scalars['String']['input'];
};


export type QueryGetProductReviewFromJaneArgs = {
  account_id: Scalars['String']['input'];
  id: Scalars['String']['input'];
  store_id: Scalars['String']['input'];
};


export type QueryGetPromotionArgs = {
  account_id: Scalars['String']['input'];
  promotion_id: Scalars['String']['input'];
  store_id: Scalars['String']['input'];
};


export type QueryGetReviewArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetSnapshotArgs = {
  account_id: Scalars['String']['input'];
  option: Scalars['Int']['input'];
  store_id: Scalars['String']['input'];
};


export type QueryGetStatsArgs = {
  account_id: Scalars['String']['input'];
  store_id: Scalars['String']['input'];
};


export type QueryGetStoreArgs = {
  account_id: Scalars['String']['input'];
  store_id: Scalars['String']['input'];
};


export type QueryGetStoreAppArgs = {
  account_id: Scalars['String']['input'];
  app_id: Scalars['String']['input'];
  store_id: Scalars['String']['input'];
};


export type QueryGetStoreNotificationSettingArgs = {
  account_id: Scalars['String']['input'];
  handler: Scalars['String']['input'];
  store_id: Scalars['String']['input'];
};


export type QueryGetTagArgs = {
  account_id: Scalars['String']['input'];
  store_id: Scalars['String']['input'];
  tag_id: Scalars['String']['input'];
};


export type QueryGetTreezHeadlessConfigArgs = {
  account_id: Scalars['String']['input'];
  customerType: CustomerType;
  provider_id: Scalars['String']['input'];
  store_id: Scalars['String']['input'];
  strictMedicalCustomerType?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetTreezHeadlessDiscountsArgs = {
  account_id: Scalars['String']['input'];
  provider_id: Scalars['String']['input'];
  store_id: Scalars['String']['input'];
};


export type QueryGetTreezHeadlessGroupsArgs = {
  account_id: Scalars['String']['input'];
  provider_id: Scalars['String']['input'];
  store_id: Scalars['String']['input'];
};


export type QueryGetTreezPayTokenArgs = {
  account_id: Scalars['String']['input'];
  entity_id: Scalars['String']['input'];
  provider_store_id: Scalars['String']['input'];
  store_id: Scalars['String']['input'];
};


export type QueryGetUserArgs = {
  user_id: Scalars['String']['input'];
};


export type QueryGetVendorArgs = {
  account_id: Scalars['String']['input'];
  store_id: Scalars['String']['input'];
  vendor_id: Scalars['String']['input'];
};


export type QueryListAccountsArgs = {
  account_filter?: InputMaybe<AccountFilter>;
  account_id: Scalars['String']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  store_id: Scalars['String']['input'];
};


export type QueryListActivePromotionsArgs = {
  account_id: Scalars['String']['input'];
  store_id: Scalars['String']['input'];
};


export type QueryListBrandsArgs = {
  account_id: Scalars['String']['input'];
  store_id: Scalars['String']['input'];
};


export type QueryListCategoryArgs = {
  account_id: Scalars['String']['input'];
  store_id: Scalars['String']['input'];
};


export type QueryListHubsArgs = {
  account_id: Scalars['String']['input'];
  store_id: Scalars['String']['input'];
};


export type QueryListInventoriesArgs = {
  account_id: Scalars['String']['input'];
  store_id: Scalars['String']['input'];
};


export type QueryListJaneSpecialsArgs = {
  account_id: Scalars['String']['input'];
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  enabled_today?: InputMaybe<Scalars['Boolean']['input']>;
  flush_cache?: InputMaybe<Scalars['Boolean']['input']>;
  jane_store_id?: InputMaybe<Array<Scalars['String']['input']>>;
  store_id: Scalars['String']['input'];
};


export type QueryListJaneStoresArgs = {
  account_id: Scalars['String']['input'];
  store_id: Scalars['String']['input'];
};


export type QueryListLandingsArgs = {
  account_id: Scalars['String']['input'];
  store_id: Scalars['String']['input'];
};


export type QueryListNavigationsArgs = {
  account_id: Scalars['String']['input'];
  store_id: Scalars['String']['input'];
};


export type QueryListNotificationSettingsArgs = {
  type?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListOptionsArgs = {
  account_id: Scalars['String']['input'];
  filter?: InputMaybe<OptionFilterInput>;
  store_id: Scalars['String']['input'];
};


export type QueryListPagesArgs = {
  account_id: Scalars['String']['input'];
  store_id: Scalars['String']['input'];
};


export type QueryListPagesByTemplateArgs = {
  account_id: Scalars['String']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  store_id: Scalars['String']['input'];
  template: Template;
};


export type QueryListProductsArgs = {
  account_id: Scalars['String']['input'];
  store_id: Scalars['String']['input'];
};


export type QueryListPromotionsArgs = {
  account_id: Scalars['String']['input'];
  store_id: Scalars['String']['input'];
};


export type QueryListStoreAppsArgs = {
  account_id: Scalars['String']['input'];
  category?: InputMaybe<AppCategoryType>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  store_id: Scalars['String']['input'];
};


export type QueryListStoreNotificationSettingsArgs = {
  account_id: Scalars['String']['input'];
  store_id: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListStoreOrdersArgs = {
  account_id: Scalars['String']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
  store_id: Scalars['String']['input'];
};


export type QueryListStoresFromAccountArgs = {
  account_id: Scalars['String']['input'];
};


export type QueryListTagArgs = {
  account_id: Scalars['String']['input'];
  store_id: Scalars['String']['input'];
};


export type QueryListTerminalInventoryArgs = {
  account_id: Scalars['String']['input'];
  inventory_id: Scalars['String']['input'];
  store_id: Scalars['String']['input'];
};


export type QueryListUsersArgs = {
  account_id: Scalars['String']['input'];
  store_id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListVendorsArgs = {
  account_id: Scalars['String']['input'];
  store_id: Scalars['String']['input'];
};


export type QueryListWorkersInLocationArgs = {
  account_id: Scalars['String']['input'];
  location?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  radius?: InputMaybe<Scalars['Float']['input']>;
  store_id: Scalars['String']['input'];
};


export type QuerySearchProductArgs = {
  account_id: Scalars['String']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  provider_store_id?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sortKey?: InputMaybe<ProductSortKeys>;
  store_id: Scalars['String']['input'];
};


export type QuerySearchTreezHeadlessProductsArgs = {
  account_id: Scalars['String']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  provider_id: Scalars['String']['input'];
  search_term?: InputMaybe<Scalars['String']['input']>;
  showOutOfStock?: InputMaybe<Scalars['Boolean']['input']>;
  store_id: Scalars['String']['input'];
  strictMedicalCustomerType?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryVerifyContactAlpineIqArgs = {
  account_id: Scalars['String']['input'];
  store_id: Scalars['String']['input'];
};


export type QueryViewContactWalletAlpineIqArgs = {
  account_id: Scalars['String']['input'];
  code?: InputMaybe<Scalars['String']['input']>;
  store_id: Scalars['String']['input'];
};

export type QuickBook = App & {
  __typename?: 'QuickBook';
  access_token?: Maybe<Scalars['String']['output']>;
  category: AppCategoryType;
  created_at?: Maybe<Scalars['TimeStamp']['output']>;
  expires_in?: Maybe<Scalars['TimeStamp']['output']>;
  handler: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  realmid?: Maybe<Scalars['String']['output']>;
  refresh_token?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
  token_type?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['TimeStamp']['output']>;
  x_refresh_token_expires_in?: Maybe<Scalars['TimeStamp']['output']>;
};

export type QuickBookInput = {
  access_token?: InputMaybe<Scalars['String']['input']>;
  category: AppCategoryType;
  created_at?: InputMaybe<Scalars['TimeStamp']['input']>;
  expires_in?: InputMaybe<Scalars['TimeStamp']['input']>;
  handler: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  realmid?: InputMaybe<Scalars['String']['input']>;
  refresh_token?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  token_type?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  updated_at?: InputMaybe<Scalars['TimeStamp']['input']>;
  x_refresh_token_expires_in?: InputMaybe<Scalars['TimeStamp']['input']>;
};

export type Redirect = App & {
  __typename?: 'Redirect';
  category: AppCategoryType;
  created_at?: Maybe<Scalars['TimeStamp']['output']>;
  handler: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  links?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  name: Scalars['String']['output'];
  status?: Maybe<Scalars['Boolean']['output']>;
  type: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['TimeStamp']['output']>;
};

export type RedirectInput = {
  category: AppCategoryType;
  created_at?: InputMaybe<Scalars['TimeStamp']['input']>;
  handler: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  links: Array<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  status?: InputMaybe<Scalars['Boolean']['input']>;
  type: Scalars['String']['input'];
  updated_at?: InputMaybe<Scalars['TimeStamp']['input']>;
};

export type Regions = {
  __typename?: 'Regions';
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type RegionsInput = {
  label?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum ReservationMode {
  All = 'ALL',
  Delivery = 'DELIVERY',
  Pickup = 'PICKUP'
}

export type ResetUserPasswordInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type ReverseProxy = App & {
  __typename?: 'ReverseProxy';
  category: AppCategoryType;
  created_at?: Maybe<Scalars['TimeStamp']['output']>;
  handler: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  links?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  name: Scalars['String']['output'];
  status?: Maybe<Scalars['Boolean']['output']>;
  type: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['TimeStamp']['output']>;
};

export type ReverseProxyInput = {
  category: AppCategoryType;
  created_at?: InputMaybe<Scalars['TimeStamp']['input']>;
  handler: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  links: Array<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  status?: InputMaybe<Scalars['Boolean']['input']>;
  type: Scalars['String']['input'];
  updated_at?: InputMaybe<Scalars['TimeStamp']['input']>;
};

export type Review = {
  __typename?: 'Review';
  id?: Maybe<Scalars['String']['output']>;
};

export enum Role {
  Admin = 'ADMIN',
  Customer = 'CUSTOMER',
  Saller = 'SALLER',
  SuperAdmin = 'SUPER_ADMIN'
}

export type ScheduleWorkingHours = {
  __typename?: 'ScheduleWorkingHours';
  day_of_the_week?: Maybe<WeekDay>;
  end?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['String']['output']>;
};

export type ScheduleWorkingHoursInput = {
  day_of_the_week?: InputMaybe<WeekDay>;
  end?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['String']['input']>;
};

export type ScheduleZone = {
  __typename?: 'ScheduleZone';
  delivery_fee?: Maybe<Scalars['Int']['output']>;
  express_menu_config?: Maybe<ExpressMenuConfig>;
  free_after?: Maybe<Scalars['Int']['output']>;
  geo_type?: Maybe<GeoType>;
  min?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  polygon_geo_zone?: Maybe<Scalars['String']['output']>;
  radius?: Maybe<Scalars['Int']['output']>;
  stores_provider_id: Scalars['String']['output'];
  time_slots?: Maybe<Array<Maybe<TimeSlot>>>;
  working_hours?: Maybe<Array<Maybe<ScheduleWorkingHours>>>;
  zips?: Maybe<Scalars['String']['output']>;
};

export type ScheduleZoneInput = {
  delivery_fee?: InputMaybe<Scalars['Int']['input']>;
  express_menu_config?: InputMaybe<ExpressMenuConfigInput>;
  free_after?: InputMaybe<Scalars['Int']['input']>;
  geo_type?: InputMaybe<GeoType>;
  min?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  polygon_geo_zone?: InputMaybe<Scalars['String']['input']>;
  radius?: InputMaybe<Scalars['Int']['input']>;
  stores_provider_id: Scalars['String']['input'];
  time_slots?: InputMaybe<Array<InputMaybe<TimeSlotInput>>>;
  working_hours?: InputMaybe<Array<InputMaybe<ScheduleWorkingHoursInput>>>;
  zips?: InputMaybe<Scalars['String']['input']>;
};

export type Seo = {
  __typename?: 'Seo';
  include_local_schema?: Maybe<Scalars['Boolean']['output']>;
  meta_description?: Maybe<Scalars['String']['output']>;
  meta_image?: Maybe<Scalars['String']['output']>;
  meta_robots?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type SeoInput = {
  include_local_schema?: InputMaybe<Scalars['Boolean']['input']>;
  meta_description?: InputMaybe<Scalars['String']['input']>;
  meta_image?: InputMaybe<Scalars['String']['input']>;
  meta_robots?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type ShippingSetting = {
  __typename?: 'ShippingSetting';
  flat_rate_method?: Maybe<FlatRateMethod>;
  free_shipping_method?: Maybe<FreeShippingMethod>;
  fulfilment_center?: Maybe<FulfilmentCenter>;
  local_delivery_method?: Maybe<LocalDelivery>;
  local_pickup_method?: Maybe<LocalPickUp>;
  store_level_method?: Maybe<StoreLevelMethod>;
};

export type ShippingSettingInput = {
  flat_rate_method?: InputMaybe<FlatRateMethodInput>;
  free_shipping_method?: InputMaybe<FreeShippingMethodInput>;
  fulfilment_center?: InputMaybe<FulfilmentCenterInput>;
  local_delivery_method?: InputMaybe<LocalDeliveryInput>;
  local_pickup_method?: InputMaybe<LocalPickUpInput>;
  store_level_method?: InputMaybe<StoreLevelMethodInput>;
};

export type StatDaily = {
  __typename?: 'StatDaily';
  month?: Maybe<Scalars['String']['output']>;
  subtotal?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type StatSnapShot = {
  __typename?: 'StatSnapShot';
  labels?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  subtotal?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  total?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  total_sales: Scalars['Int']['output'];
  total_sales_amount: Scalars['Int']['output'];
};

export type Stats = {
  __typename?: 'Stats';
  anual?: Maybe<Array<Maybe<StatDaily>>>;
  growth?: Maybe<Array<Maybe<GrowthStat>>>;
  snapshot?: Maybe<StatSnapShot>;
  top_products?: Maybe<Array<Maybe<TopProductStat>>>;
  total_sales: Scalars['Int']['output'];
  total_sales_amount: Scalars['Int']['output'];
};

export type Store = {
  __typename?: 'Store';
  account_setting?: Maybe<AccountSetting>;
  ach_payment_banner_url?: Maybe<Scalars['String']['output']>;
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  agreements?: Maybe<Array<Maybe<StoreAgreement>>>;
  algolia_order_index?: Maybe<Scalars['String']['output']>;
  aws_pinpoint_analytics?: Maybe<AwsPinpointAnalytics>;
  aws_profile?: Maybe<Scalars['String']['output']>;
  aws_region?: Maybe<Scalars['String']['output']>;
  business_description?: Maybe<Scalars['String']['output']>;
  business_slogan?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  closures?: Maybe<Array<Maybe<Closure>>>;
  country?: Maybe<Scalars['String']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  country_name?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['TimeStamp']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  debit_card_fee?: Maybe<Scalars['Int']['output']>;
  delivery?: Maybe<Delivery>;
  delivery_hours?: Maybe<Array<Maybe<StoreWorkingHourSetting>>>;
  delivery_schedules?: Maybe<Array<Maybe<ScheduleZone>>>;
  disabled_time_window?: Maybe<Scalars['Boolean']['output']>;
  display_post_tax?: Maybe<Scalars['Boolean']['output']>;
  domain?: Maybe<Scalars['String']['output']>;
  dynamo_order_table_name?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  email_notification_active?: Maybe<Scalars['Boolean']['output']>;
  facebook?: Maybe<Scalars['String']['output']>;
  feature_flags?: Maybe<FeatureFlag>;
  first_name?: Maybe<Scalars['String']['output']>;
  from_tx_email?: Maybe<Scalars['String']['output']>;
  google_map_api_url?: Maybe<Scalars['String']['output']>;
  gtm_active?: Maybe<Scalars['Boolean']['output']>;
  gtm_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  instagram?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  license?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  logo_small?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  medias?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  min_order_amount?: Maybe<Scalars['Int']['output']>;
  money_format?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  number_of_days_in_advance?: Maybe<Scalars['Int']['output']>;
  opensearch_order_index?: Maybe<Scalars['String']['output']>;
  payment_settings?: Maybe<Array<Maybe<StorePaymentSettings>>>;
  phone_number?: Maybe<Scalars['String']['output']>;
  pickup_hours?: Maybe<Array<Maybe<StoreWorkingHourSetting>>>;
  pickup_schedules?: Maybe<Array<Maybe<PickupScheduleZone>>>;
  prismic_api_endpoint?: Maybe<Scalars['String']['output']>;
  provider_deployment_url?: Maybe<Scalars['String']['output']>;
  province?: Maybe<Scalars['String']['output']>;
  province_code?: Maybe<Scalars['String']['output']>;
  s3_bucket?: Maybe<Scalars['String']['output']>;
  shipping_setting?: Maybe<ShippingSetting>;
  show_reward_at_checkout?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
  store_cache_version?: Maybe<Scalars['String']['output']>;
  store_feature?: Maybe<Array<Maybe<StoreFeature>>>;
  tax_active?: Maybe<Scalars['Boolean']['output']>;
  tax_ammont?: Maybe<Scalars['Int']['output']>;
  tax_type?: Maybe<TaxType>;
  tier_plan?: Maybe<TierPlanType>;
  timezone?: Maybe<Scalars['String']['output']>;
  twitter?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['TimeStamp']['output']>;
  vercel_project_id?: Maybe<Scalars['String']['output']>;
  vercel_team_id?: Maybe<Scalars['String']['output']>;
  warning_setting?: Maybe<Scalars['String']['output']>;
  working_hours?: Maybe<Array<Maybe<StoreWorkingHourSetting>>>;
  yelp?: Maybe<Scalars['String']['output']>;
  youtube?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type StoreAgreement = {
  __typename?: 'StoreAgreement';
  check_by_default?: Maybe<Scalars['Boolean']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
  reservation_mode: ReservationMode;
  stores_provider_ids?: Maybe<Array<Scalars['String']['output']>>;
};

export type StoreAgreementInput = {
  check_by_default?: InputMaybe<Scalars['Boolean']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  reservation_mode: ReservationMode;
  stores_provider_ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type StoreFeature = {
  __typename?: 'StoreFeature';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type StoreFeatureInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StoreInput = {
  account_setting?: InputMaybe<AccountSettingInput>;
  ach_payment_banner_url?: InputMaybe<Scalars['String']['input']>;
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  agreements?: InputMaybe<Array<InputMaybe<StoreAgreementInput>>>;
  algolia_order_index?: InputMaybe<Scalars['String']['input']>;
  aws_pinpoint_analytics?: InputMaybe<AwsPinpointAnalyticsInput>;
  aws_profile?: InputMaybe<Scalars['String']['input']>;
  aws_region?: InputMaybe<Scalars['String']['input']>;
  business_description?: InputMaybe<Scalars['String']['input']>;
  business_slogan?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  closures?: InputMaybe<Array<InputMaybe<ClosureInput>>>;
  country?: InputMaybe<Scalars['String']['input']>;
  country_code?: InputMaybe<Scalars['String']['input']>;
  country_name?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['TimeStamp']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  debit_card_fee?: InputMaybe<Scalars['Int']['input']>;
  delivery?: InputMaybe<DeliveryInput>;
  delivery_hours?: InputMaybe<Array<InputMaybe<StoreWorkingHourSettingInput>>>;
  delivery_schedules?: InputMaybe<Array<InputMaybe<ScheduleZoneInput>>>;
  disabled_time_window?: InputMaybe<Scalars['Boolean']['input']>;
  display_post_tax?: InputMaybe<Scalars['Boolean']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  dynamo_order_table_name?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  email_notification_active?: InputMaybe<Scalars['Boolean']['input']>;
  facebook?: InputMaybe<Scalars['String']['input']>;
  feature_flags?: InputMaybe<FeatureFlagInput>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  from_tx_email?: InputMaybe<Scalars['String']['input']>;
  google_map_api_url?: InputMaybe<Scalars['String']['input']>;
  gtm_active?: InputMaybe<Scalars['Boolean']['input']>;
  gtm_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  license?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  logo_small?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  medias?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  min_order_amount?: InputMaybe<Scalars['Int']['input']>;
  money_format?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  number_of_days_in_advance?: InputMaybe<Scalars['Int']['input']>;
  opensearch_order_index?: InputMaybe<Scalars['String']['input']>;
  payment_settings?: InputMaybe<Array<InputMaybe<StorePaymentSettingsInput>>>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  pickup_hours?: InputMaybe<Array<InputMaybe<StoreWorkingHourSettingInput>>>;
  pickup_schedules?: InputMaybe<Array<InputMaybe<PickupScheduleZoneInput>>>;
  prismic_api_endpoint?: InputMaybe<Scalars['String']['input']>;
  provider_deployment_url?: InputMaybe<Scalars['String']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
  province_code?: InputMaybe<Scalars['String']['input']>;
  s3_bucket?: InputMaybe<Scalars['String']['input']>;
  shipping_setting?: InputMaybe<ShippingSettingInput>;
  show_reward_at_checkout?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  store_cache_version?: InputMaybe<Scalars['String']['input']>;
  store_feature?: InputMaybe<Array<InputMaybe<StoreFeatureInput>>>;
  tax_active?: InputMaybe<Scalars['Boolean']['input']>;
  tax_ammont?: InputMaybe<Scalars['Int']['input']>;
  tax_type?: InputMaybe<TaxType>;
  tier_plan?: InputMaybe<TierPlanType>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  twitter?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['TimeStamp']['input']>;
  vercel_project_id?: InputMaybe<Scalars['String']['input']>;
  vercel_team_id?: InputMaybe<Scalars['String']['input']>;
  warning_setting?: InputMaybe<Scalars['String']['input']>;
  working_hours?: InputMaybe<Array<InputMaybe<StoreWorkingHourSettingInput>>>;
  yelp?: InputMaybe<Scalars['String']['input']>;
  youtube?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type StoreLevelMethod = {
  __typename?: 'StoreLevelMethod';
  active?: Maybe<Scalars['Boolean']['output']>;
  estimated_days?: Maybe<Scalars['Int']['output']>;
};

export type StoreLevelMethodInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  estimated_days?: InputMaybe<Scalars['Int']['input']>;
};

export type StoreMenu = {
  __typename?: 'StoreMenu';
  account_id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  store_id?: Maybe<Scalars['String']['output']>;
};

export type StorePaymentSettings = {
  __typename?: 'StorePaymentSettings';
  payment_type?: Maybe<StorePaymentType>;
  reservation_mode: ReservationMode;
  stores_provider_ids?: Maybe<Array<Scalars['String']['output']>>;
};

export type StorePaymentSettingsInput = {
  payment_type?: InputMaybe<StorePaymentType>;
  reservation_mode: ReservationMode;
  stores_provider_ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum StorePaymentType {
  Ach = 'ACH',
  Cash = 'CASH',
  Credit = 'CREDIT',
  Debit = 'DEBIT'
}

export type StoreWorkingHourSetting = {
  __typename?: 'StoreWorkingHourSetting';
  day?: Maybe<Scalars['String']['output']>;
  period?: Maybe<StoreWorkingPeriodSetting>;
};

export type StoreWorkingHourSettingInput = {
  day?: InputMaybe<Scalars['String']['input']>;
  period?: InputMaybe<StoreWorkingPeriodSettingInput>;
};

export type StoreWorkingPeriodSetting = {
  __typename?: 'StoreWorkingPeriodSetting';
  from?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Scalars['String']['output']>;
};

export type StoreWorkingPeriodSettingInput = {
  from?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
};

export type Stronghold = App & {
  __typename?: 'Stronghold';
  category: AppCategoryType;
  created_at?: Maybe<Scalars['TimeStamp']['output']>;
  credentials?: Maybe<Array<StrongholdCredentials>>;
  handler: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  status?: Maybe<Scalars['Boolean']['output']>;
  type: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['TimeStamp']['output']>;
};

export type StrongholdCredentials = {
  __typename?: 'StrongholdCredentials';
  allow_tiping?: Maybe<Scalars['Boolean']['output']>;
  api_host?: Maybe<Scalars['String']['output']>;
  sh_integration_key?: Maybe<Scalars['String']['output']>;
  sh_secret_key?: Maybe<Scalars['String']['output']>;
  store_provider_id?: Maybe<Scalars['String']['output']>;
};

export type StrongholdCredentialsInput = {
  allow_tiping?: InputMaybe<Scalars['Boolean']['input']>;
  api_host: Scalars['String']['input'];
  sh_integration_key: Scalars['String']['input'];
  sh_secret_key: Scalars['String']['input'];
  store_provider_id: Scalars['String']['input'];
};

export type StrongholdInput = {
  category: AppCategoryType;
  created_at?: InputMaybe<Scalars['TimeStamp']['input']>;
  credentials?: InputMaybe<Array<StrongholdCredentialsInput>>;
  handler: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  status?: InputMaybe<Scalars['Boolean']['input']>;
  type: Scalars['String']['input'];
  updated_at?: InputMaybe<Scalars['TimeStamp']['input']>;
};

export enum StrongholdPayLinkStatus {
  Canceled = 'CANCELED',
  Created = 'CREATED',
  Used = 'USED'
}

export enum StrongholdPayType {
  BankLink = 'BANK_LINK',
  Checkout = 'CHECKOUT',
  Tipping = 'TIPPING'
}

export type StrongholdPaymentDetail = {
  __typename?: 'StrongholdPaymentDetail';
  charge_id?: Maybe<Scalars['String']['output']>;
  order_id?: Maybe<Scalars['String']['output']>;
  paylink_id: Scalars['String']['output'];
  status?: Maybe<StrongholdPayLinkStatus>;
};

export type SubscribeCrmAddressInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type SubscribeCrmInput = {
  address?: InputMaybe<SubscribeCrmAddressInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  lists?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  phone?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<SubscriptionSourceType>;
  unsubscribe?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubscriptionInput = {
  email?: InputMaybe<Scalars['String']['input']>;
};

export enum SubscriptionSourceType {
  Account = 'ACCOUNT',
  Footer = 'FOOTER',
  Popup = 'POPUP',
  Signup = 'SIGNUP'
}

export type Surfside = App & {
  __typename?: 'Surfside';
  account_id: Scalars['String']['output'];
  active?: Maybe<Scalars['Boolean']['output']>;
  category: AppCategoryType;
  channel_id: Scalars['String']['output'];
  created_at?: Maybe<Scalars['TimeStamp']['output']>;
  handler: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  source_id: Scalars['String']['output'];
  status?: Maybe<Scalars['Boolean']['output']>;
  type: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['TimeStamp']['output']>;
};

export type SurfsideInput = {
  account_id: Scalars['String']['input'];
  active?: InputMaybe<Scalars['Boolean']['input']>;
  category: AppCategoryType;
  channel_id: Scalars['String']['input'];
  created_at?: InputMaybe<Scalars['TimeStamp']['input']>;
  handler: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  source_id: Scalars['String']['input'];
  status?: InputMaybe<Scalars['Boolean']['input']>;
  type: Scalars['String']['input'];
  updated_at?: InputMaybe<Scalars['TimeStamp']['input']>;
};

export type Swifter = App & {
  __typename?: 'Swifter';
  category: AppCategoryType;
  created_at?: Maybe<Scalars['TimeStamp']['output']>;
  credentials?: Maybe<Array<SwifterCredentials>>;
  handler: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  status?: Maybe<Scalars['Boolean']['output']>;
  type: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['TimeStamp']['output']>;
};

export type SwifterCredentials = {
  __typename?: 'SwifterCredentials';
  api_host?: Maybe<Scalars['String']['output']>;
  auth_host?: Maybe<Scalars['String']['output']>;
  client_id?: Maybe<Scalars['String']['output']>;
  client_secret?: Maybe<Scalars['String']['output']>;
  sandbox?: Maybe<Scalars['Boolean']['output']>;
  store_provider_id?: Maybe<Scalars['String']['output']>;
};

export type SwifterCredentialsInput = {
  api_host: Scalars['String']['input'];
  auth_host: Scalars['String']['input'];
  client_id: Scalars['String']['input'];
  client_secret: Scalars['String']['input'];
  sandbox?: InputMaybe<Scalars['Boolean']['input']>;
  store_provider_id: Scalars['String']['input'];
};

export type SwifterInput = {
  category: AppCategoryType;
  created_at?: InputMaybe<Scalars['TimeStamp']['input']>;
  credentials?: InputMaybe<Array<SwifterCredentialsInput>>;
  handler: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  status?: InputMaybe<Scalars['Boolean']['input']>;
  type: Scalars['String']['input'];
  updated_at?: InputMaybe<Scalars['TimeStamp']['input']>;
};

export type SwifterPaymentDetail = {
  __typename?: 'SwifterPaymentDetail';
  order_id?: Maybe<Scalars['String']['output']>;
  session_id: Scalars['String']['output'];
  status?: Maybe<SwifterStatus>;
  track_number?: Maybe<Scalars['String']['output']>;
};

export enum SwifterStatus {
  Completed = 'COMPLETED',
  Started = 'STARTED'
}

export type System = App & {
  __typename?: 'System';
  category: AppCategoryType;
  created_at?: Maybe<Scalars['TimeStamp']['output']>;
  handler: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  status?: Maybe<Scalars['Boolean']['output']>;
  type: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['TimeStamp']['output']>;
};

export type SystemAppInput = {
  category: AppCategoryType;
  created_at?: InputMaybe<Scalars['TimeStamp']['input']>;
  handler: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  status?: InputMaybe<Scalars['Boolean']['input']>;
  type: Scalars['String']['input'];
  updated_at?: InputMaybe<Scalars['TimeStamp']['input']>;
};

export type Tag = {
  __typename?: 'Tag';
  create_date?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type TagInput = {
  create_date?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export enum Target {
  Blank = '_blank',
  Parent = '_parent',
  Self = '_self',
  Top = '_top'
}

export type Tax = {
  __typename?: 'Tax';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  rate?: Maybe<Scalars['Int']['output']>;
  territory?: Maybe<Scalars['String']['output']>;
};

export type TaxInfo = {
  __typename?: 'TaxInfo';
  city_tax?: Maybe<Scalars['Int']['output']>;
  federal_tax?: Maybe<Scalars['Int']['output']>;
  state_tax?: Maybe<Scalars['Int']['output']>;
};

export type TaxInfoInput = {
  city_tax?: InputMaybe<Scalars['Int']['input']>;
  federal_tax?: InputMaybe<Scalars['Int']['input']>;
  state_tax?: InputMaybe<Scalars['Int']['input']>;
};

export type TaxInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  rate?: InputMaybe<Scalars['Int']['input']>;
  territory?: InputMaybe<Scalars['String']['input']>;
};

export type TaxTable = {
  __typename?: 'TaxTable';
  city_tax?: Maybe<Tax>;
  county_tax?: Maybe<Tax>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  federal_tax?: Maybe<Tax>;
  state_tax?: Maybe<Tax>;
};

export type TaxTableInput = {
  city_tax?: InputMaybe<TaxInput>;
  county_tax?: InputMaybe<TaxInput>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  federal_tax?: InputMaybe<TaxInput>;
  state_tax?: InputMaybe<TaxInput>;
};

export enum TaxType {
  FlatRate = 'FLAT_RATE',
  Percentage = 'PERCENTAGE'
}

export enum Template {
  About = 'ABOUT',
  Article = 'ARTICLE',
  Blog = 'BLOG',
  Brand = 'BRAND',
  BrandsList = 'BRANDS_LIST',
  Catalog = 'CATALOG',
  City = 'CITY',
  Contact = 'CONTACT',
  Home = 'HOME',
  Location = 'LOCATION',
  Menu = 'MENU',
  Product = 'PRODUCT',
  SiteMap = 'SITE_MAP',
  Specials = 'SPECIALS',
  State = 'STATE',
  Text = 'TEXT'
}

export enum TierMethod {
  BulkWeight = 'BULK_WEIGHT',
  Unit = 'UNIT',
  WeightGrams = 'WEIGHT_GRAMS'
}

export enum TierPlanType {
  Scale = 'SCALE',
  Startup = 'STARTUP'
}

export type TimeSlot = {
  __typename?: 'TimeSlot';
  cutoff_time?: Maybe<Scalars['String']['output']>;
  day_of_the_week?: Maybe<WeekDay>;
  disable?: Maybe<Scalars['Boolean']['output']>;
  disable_for_today?: Maybe<Scalars['Boolean']['output']>;
  end?: Maybe<Scalars['String']['output']>;
  is_express?: Maybe<Scalars['Boolean']['output']>;
  start?: Maybe<Scalars['String']['output']>;
};

export type TimeSlotInput = {
  cutoff_time?: InputMaybe<Scalars['String']['input']>;
  day_of_the_week?: InputMaybe<WeekDay>;
  disable?: InputMaybe<Scalars['Boolean']['input']>;
  disable_for_today?: InputMaybe<Scalars['Boolean']['input']>;
  end?: InputMaybe<Scalars['String']['input']>;
  is_express?: InputMaybe<Scalars['Boolean']['input']>;
  start?: InputMaybe<Scalars['String']['input']>;
};

export type TopProductStat = {
  __typename?: 'TopProductStat';
  id?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  qty?: Maybe<Scalars['Int']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type Treez = App & {
  __typename?: 'Treez';
  automatic_approval?: Maybe<Scalars['Boolean']['output']>;
  category: AppCategoryType;
  created_at?: Maybe<Scalars['TimeStamp']['output']>;
  credentials: Array<TreezData>;
  handler: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  sandbox?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
  type: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['TimeStamp']['output']>;
};

export type TreezCustomerInfo = {
  __typename?: 'TreezCustomerInfo';
  treez_customer_id: Scalars['String']['output'];
  treez_dl_updated: Scalars['Boolean']['output'];
};

export type TreezData = {
  __typename?: 'TreezData';
  active?: Maybe<Scalars['Boolean']['output']>;
  api_key: Scalars['String']['output'];
  client_id: Scalars['String']['output'];
  default_store?: Maybe<Scalars['Boolean']['output']>;
  dispensary_name: Scalars['String']['output'];
  headless_client_id?: Maybe<Scalars['String']['output']>;
  headless_client_secret?: Maybe<Scalars['String']['output']>;
  store_id: Scalars['String']['output'];
  store_name: Scalars['String']['output'];
};

export type TreezDataInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  api_key: Scalars['String']['input'];
  client_id: Scalars['String']['input'];
  default_store?: InputMaybe<Scalars['Boolean']['input']>;
  dispensary_name: Scalars['String']['input'];
  headless_client_id?: InputMaybe<Scalars['String']['input']>;
  headless_client_secret?: InputMaybe<Scalars['String']['input']>;
  store_id: Scalars['String']['input'];
  store_name: Scalars['String']['input'];
};

export type TreezHeadlessAddress = {
  __typename?: 'TreezHeadlessAddress';
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  latitude: Scalars['String']['output'];
  longitude: Scalars['String']['output'];
  state: Scalars['String']['output'];
  street: Scalars['String']['output'];
  zip: Scalars['String']['output'];
};

export type TreezHeadlessConfig = {
  __typename?: 'TreezHeadlessConfig';
  address: TreezHeadlessAddress;
  locations?: Maybe<Array<TreezHeadlessLocation>>;
  short_name: Scalars['String']['output'];
};

export type TreezHeadlessDiscount = {
  __typename?: 'TreezHeadlessDiscount';
  active: Scalars['Boolean']['output'];
  adjustment: Scalars['Boolean']['output'];
  amount: Scalars['Float']['output'];
  cart: Scalars['Boolean']['output'];
  currentFlag: Scalars['Boolean']['output'];
  discount_numeric_type: Scalars['String']['output'];
  groups?: Maybe<Array<Scalars['String']['output']>>;
  groups_required?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['String']['output'];
  method: Scalars['String']['output'];
  require_coupon: Scalars['Boolean']['output'];
  rewardable: Scalars['Boolean']['output'];
  stackable: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
};

export type TreezHeadlessGroup = {
  __typename?: 'TreezHeadlessGroup';
  current_flag: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  in_list: Scalars['String']['output'];
  name: Scalars['String']['output'];
  out_list: Scalars['String']['output'];
  restaurant_id: Scalars['Int']['output'];
  rules: Scalars['String']['output'];
  syncing: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
};

export type TreezHeadlessLocation = {
  __typename?: 'TreezHeadlessLocation';
  id: Scalars['String']['output'];
  inventory_type: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type TreezInput = {
  automatic_approval?: InputMaybe<Scalars['Boolean']['input']>;
  category: AppCategoryType;
  created_at?: InputMaybe<Scalars['TimeStamp']['input']>;
  credentials?: InputMaybe<Array<TreezDataInput>>;
  handler: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  sandbox?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  type: Scalars['String']['input'];
  updated_at?: InputMaybe<Scalars['TimeStamp']['input']>;
};

export type TreezPay = App & {
  __typename?: 'TreezPay';
  category: AppCategoryType;
  created_at?: Maybe<Scalars['TimeStamp']['output']>;
  credentials?: Maybe<Array<TreezPayCredentials>>;
  handler: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  status?: Maybe<Scalars['Boolean']['output']>;
  type: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['TimeStamp']['output']>;
};

export type TreezPayCredentials = {
  __typename?: 'TreezPayCredentials';
  entity_id?: Maybe<Scalars['String']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  sandbox?: Maybe<Scalars['Boolean']['output']>;
  store_provider_id?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type TreezPayCredentialsInput = {
  entity_id: Scalars['String']['input'];
  password: Scalars['String']['input'];
  sandbox?: InputMaybe<Scalars['Boolean']['input']>;
  store_provider_id: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type TreezPayInput = {
  category: AppCategoryType;
  created_at?: InputMaybe<Scalars['TimeStamp']['input']>;
  credentials?: InputMaybe<Array<TreezPayCredentialsInput>>;
  handler: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  status?: InputMaybe<Scalars['Boolean']['input']>;
  type: Scalars['String']['input'];
  updated_at?: InputMaybe<Scalars['TimeStamp']['input']>;
};

export type TreezPayPaymentDetail = {
  __typename?: 'TreezPayPaymentDetail';
  invoice_id?: Maybe<Scalars['String']['output']>;
  payment_id?: Maybe<Scalars['String']['output']>;
  payment_method?: Maybe<Scalars['String']['output']>;
  processor_name: Scalars['String']['output'];
};

export type TreezPayPaymentDetailInput = {
  invoice_id?: InputMaybe<Scalars['String']['input']>;
  payment_id?: InputMaybe<Scalars['String']['input']>;
  payment_method?: InputMaybe<Scalars['String']['input']>;
  processor_name: Scalars['String']['input'];
};

export type TreezPayTicket = {
  __typename?: 'TreezPayTicket';
  created_at?: Maybe<Scalars['TimeStamp']['output']>;
  provider_store_id: Scalars['String']['output'];
  ticket_id: Scalars['String']['output'];
};

export type TreezPayTicketInput = {
  created_at?: InputMaybe<Scalars['TimeStamp']['input']>;
  provider_store_id: Scalars['String']['input'];
  ticket_id: Scalars['String']['input'];
};

export type TreezSpecial = {
  __typename?: 'TreezSpecial';
  amount: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type UpdateAccountInput = {
  accept_marketing?: InputMaybe<Scalars['Boolean']['input']>;
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  city_code?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  country_code?: InputMaybe<Scalars['String']['input']>;
  date_of_birth?: InputMaybe<Scalars['TimeStamp']['input']>;
  driver_license_id?: InputMaybe<Scalars['String']['input']>;
  driver_license_id_expiration_date?: InputMaybe<Scalars['TimeStamp']['input']>;
  driver_license_photo?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<GenderType>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  medical_id?: InputMaybe<AccountMedicalIdInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  photo?: InputMaybe<Scalars['String']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
  province_code?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Scalars['String']['input']>;
  treez_ids?: InputMaybe<Array<InputMaybe<AccountTreezIdInput>>>;
  type?: InputMaybe<AccountType>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateBerbixVerificationStatus = {
  accept: Scalars['Boolean']['input'];
  email: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDutchieCartResponse = {
  __typename?: 'UpdateDutchieCartResponse';
  error?: Maybe<ErrorResponse>;
  order?: Maybe<Order>;
  status: Scalars['Boolean']['output'];
};

export type UpdateIdpAccount = {
  berbix_error?: InputMaybe<Scalars['String']['input']>;
  berbix_id?: InputMaybe<Scalars['String']['input']>;
  berbix_refresh_token?: InputMaybe<Scalars['String']['input']>;
  berbix_verified?: InputMaybe<Scalars['Boolean']['input']>;
  email: Scalars['String']['input'];
  enable?: InputMaybe<Scalars['Boolean']['input']>;
  role?: InputMaybe<Role>;
};

export type UpdateOrderDeliveryDetailsTimeWindow = {
  deliver_after?: InputMaybe<Scalars['TimeStamp']['input']>;
  deliver_before?: InputMaybe<Scalars['TimeStamp']['input']>;
  time_window?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrderDetailsInput = {
  address?: InputMaybe<OrderAddressInput>;
  id: Scalars['String']['input'];
  line_items?: InputMaybe<Array<LineItemInput>>;
  notes?: InputMaybe<Scalars['String']['input']>;
  payment_method?: InputMaybe<PaymentType>;
  promo_code?: InputMaybe<Scalars['String']['input']>;
  time_window?: InputMaybe<UpdateOrderDeliveryDetailsTimeWindow>;
};

export type UpdateOrderLineItemBarCodesInput = {
  bar_codes: Array<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  weight: Scalars['String']['input'];
};

export type UpdateOrderLineItemsBarCodesInput = {
  id: Scalars['String']['input'];
  line_items: Array<UpdateOrderLineItemBarCodesInput>;
};

export type UpdateOrderStatusInput = {
  id: Scalars['String']['input'];
  status: OrderStatusType;
};

export type UpdateTreezCartResponse = {
  __typename?: 'UpdateTreezCartResponse';
  error?: Maybe<ErrorResponse>;
  order?: Maybe<Order>;
  specials?: Maybe<Array<TreezSpecial>>;
  status: Scalars['Boolean']['output'];
};

export type UploadAccountPhotoResponse = {
  __typename?: 'UploadAccountPhotoResponse';
  file_name: Scalars['String']['output'];
  headers: Array<Maybe<Header>>;
  url: Scalars['String']['output'];
};

export type User = {
  __typename?: 'User';
  account_id?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  store_id?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type UserInput = {
  account_id?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  store_id?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type Variant = {
  __typename?: 'Variant';
  discount_amount?: Maybe<Scalars['Int']['output']>;
  discount_percent?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pos_id?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  salePrice?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type VariantInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type Vendor = {
  __typename?: 'Vendor';
  address?: Maybe<OrderAddress>;
  asset?: Maybe<Asset>;
  brands?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  company_type?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['TimeStamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  fax?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  license_expiration_date?: Maybe<Scalars['TimeStamp']['output']>;
  license_number?: Maybe<Scalars['String']['output']>;
  mobile_number?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  sales_person?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['TimeStamp']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export enum WeekDay {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export type UpdateCartInput = {
  order: OrderInput;
};

export type GetAccountByEmailQueryVariables = Exact<{
  account_id: Scalars['String']['input'];
  store_id: Scalars['String']['input'];
  email: Scalars['String']['input'];
  provider_store?: InputMaybe<ProviderStore>;
}>;


export type GetAccountByEmailQuery = { __typename?: 'Query', getAccountByEmail?: { __typename?: 'Account', photo?: string | null, email?: string | null, date_of_birth?: any | null, entity_id?: string | null, first_name?: string | null, last_name?: string | null, phone?: string | null, driver_license_id?: string | null, driver_license_photo?: string | null, driver_license_id_expiration_date?: any | null, address1?: string | null, address2?: string | null, province?: string | null, province_code?: string | null, city?: string | null, city_code?: string | null, country?: string | null, country_code?: string | null, zip?: string | null, latitude?: number | null, longitude?: number | null, accept_marketing?: boolean | null, has_account?: boolean | null, checkin_from_dispensary?: boolean | null, active?: boolean | null, created_at?: any | null, updated_at?: any | null, loyalty_points?: number | null, type?: AccountType | null, gender?: GenderType | null, alpineiq_verified?: boolean | null, alpineiq_contact_id?: string | null, loyalty_points_time_line?: Array<{ __typename?: 'LoyaltyPointsTimeLine', date?: any | null, points: number, note?: string | null } | null> | null, treez_ids?: Array<{ __typename?: 'AccountTreezID', store_id: string, id: string } | null> | null, medical_id?: { __typename?: 'AccountMedicalID', number: string, expiration_date: any } | null } | null };

export type CustomerOrderHistoryQueryVariables = Exact<{
  account_id: Scalars['String']['input'];
  store_id: Scalars['String']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  total_price?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CustomerOrderHistoryQuery = { __typename?: 'Query', customerOrderHistory?: { __typename?: 'OrderCursorPagination', cursor?: string | null, orders?: Array<{ __typename?: 'Order', entity_id?: string | null, status?: OrderStatusType | null, created_at?: any | null, order_number?: number | null, treez_order_number?: string | null, total_price?: number | null, delivery_details?: { __typename?: 'OrderDelivery', delivery?: boolean | null, pickup?: boolean | null } | null, delivery_address?: { __typename?: 'OrderAddress', address1?: string | null, address2?: string | null, city?: string | null, province?: string | null, zip?: string | null, country_code?: string | null } | null, line_items?: Array<{ __typename?: 'LineItem', id?: string | null, item_id?: string | null, name?: string | null, quantity?: number | null, variants?: Array<{ __typename?: 'Variant', id?: string | null, name?: string | null, price?: number | null, salePrice?: number | null, type?: string | null } | null> | null } | null> | null } | null> | null } | null };

export type CreateAccountMutationVariables = Exact<{
  account_id: Scalars['String']['input'];
  store_id: Scalars['String']['input'];
  input: CreateAccountInput;
}>;


export type CreateAccountMutation = { __typename?: 'Mutation', createAccount?: { __typename?: 'Account', email?: string | null } | null };

export type UpdateAccountMutationVariables = Exact<{
  account_id: Scalars['String']['input'];
  store_id: Scalars['String']['input'];
  input: UpdateAccountInput;
}>;


export type UpdateAccountMutation = { __typename?: 'Mutation', updateAccount?: { __typename?: 'Account', email?: string | null } | null };

export type UploadAccountPhotoMutationVariables = Exact<{
  account_id: Scalars['String']['input'];
  store_id: Scalars['String']['input'];
  input: AccountUploadPhotoInput;
}>;


export type UploadAccountPhotoMutation = { __typename?: 'Mutation', uploadAccountPhoto?: { __typename?: 'UploadAccountPhotoResponse', file_name: string, url: string, headers: Array<{ __typename?: 'Header', key: string, value: string } | null> } | null };

export type GetAccountPhotoQueryVariables = Exact<{
  filename: Scalars['String']['input'];
}>;


export type GetAccountPhotoQuery = { __typename?: 'Query', getAccountPhoto?: string | null };

export type CreateBerbixClientTokenMutationVariables = Exact<{
  account_id: Scalars['String']['input'];
  store_id: Scalars['String']['input'];
  input: BerbixClientTokenInput;
}>;


export type CreateBerbixClientTokenMutation = { __typename?: 'Mutation', createBerbixClientToken?: { __typename?: 'BerbixClientToken', access_token: string, client_token: string, expires_at: string, refresh_token: string } | null };

export type GetBerbixTransactionResultQueryVariables = Exact<{
  account_id: Scalars['String']['input'];
  store_id: Scalars['String']['input'];
  access_token: Scalars['String']['input'];
  refresh_token: Scalars['String']['input'];
}>;


export type GetBerbixTransactionResultQuery = { __typename?: 'Query', getBerbixTransactionResult?: { __typename?: 'BerbixTransactionResult', id: string, valitated_user: boolean, reason_not_validated?: string | null } | null };

export type IdScanVerificationMutationVariables = Exact<{
  account_id: Scalars['String']['input'];
  store_id: Scalars['String']['input'];
  input: IdScanValidationInput;
}>;


export type IdScanVerificationMutation = { __typename?: 'Mutation', idScanVerification?: { __typename?: 'IDScanValidationResponse', success: boolean, error?: { __typename?: 'IDScanValidationErrorResponse', code: IdScanValidationErrorCode, text: string } | null } | null };

export type SetTreezCustomerUnverifiedMutationVariables = Exact<{ [key: string]: never; }>;


export type SetTreezCustomerUnverifiedMutation = { __typename?: 'Mutation', setTreezCustomerUnverified?: boolean | null };

export type GetOrderQueryVariables = Exact<{
  account_id: Scalars['String']['input'];
  store_id: Scalars['String']['input'];
  entity_id: Scalars['String']['input'];
}>;


export type GetOrderQuery = { __typename?: 'Query', getOrder?: { __typename?: 'Order', entity_id?: string | null, key?: string | null, status?: OrderStatusType | null, created_at?: any | null, notes?: string | null, order_number?: number | null, treez_order_number?: string | null, state_of_residence?: string | null, subtotal_price?: number | null, total_discounts?: number | null, total_line_items_price?: number | null, total_price?: number | null, total_tax?: number | null, total_delivery?: number | null, total_service_fee?: number | null, delivery_details?: { __typename?: 'OrderDelivery', pickup?: boolean | null, delivery?: boolean | null, started_at?: any | null, finished_at?: any | null } | null, delivery_address?: { __typename?: 'OrderAddress', address1?: string | null, address2?: string | null, city?: string | null, province?: string | null, zip?: string | null, country_code?: string | null, latitude?: number | null, longitude?: number | null, first_name?: string | null, last_name?: string | null, phone?: string | null } | null, line_items?: Array<{ __typename?: 'LineItem', item_id?: string | null, name?: string | null, quantity?: number | null, price?: number | null, in_stock?: boolean | null, thumbnail?: string | null, variants?: Array<{ __typename?: 'Variant', price?: number | null, salePrice?: number | null, name?: string | null, type?: string | null } | null> | null } | null> | null, payment_details?: { __typename?: 'PaymentDetail', type?: PaymentType | null, card_type?: string | null, last_four?: string | null, refunded?: boolean | null, refund_id?: string | null, treezpay_detail?: { __typename?: 'TreezPayPaymentDetail', payment_method?: string | null, processor_name: string } | null } | null, treez_pay_ticket_ids_by_store?: Array<{ __typename?: 'TreezPayTicket', provider_store_id: string, ticket_id: string, created_at?: any | null } | null> | null } | null };

export type UpdateCartMutationVariables = Exact<{
  account_id: Scalars['String']['input'];
  store_id: Scalars['String']['input'];
  input: UpdateCartInput;
}>;


export type UpdateCartMutation = { __typename?: 'Mutation', updateJaneCart?: { __typename?: 'Order', entity_id?: string | null, key?: string | null, subtotal_price?: number | null, total_line_items_price?: number | null, total_discounts?: number | null, total_price?: number | null, total_tax?: number | null, total_delivery?: number | null, total_service_fee?: number | null, jane_store_full_address?: string | null, jane_store_phone_number?: string | null, discount_items?: Array<{ __typename?: 'OrderDiscountItem', id?: string | null, blaze_id?: string | null, discountType?: DiscountType | null, discount_rate_type?: DiscountRateType | null, discount_apply_type?: DiscountApplyType | null, promo_code?: string | null, rate?: number | null } | null> | null, line_items?: Array<{ __typename?: 'LineItem', item_id?: string | null, quantity?: number | null, price?: number | null, thumbnail?: string | null, variants?: Array<{ __typename?: 'Variant', id?: string | null, name?: string | null, price?: number | null, type?: string | null } | null> | null } | null> | null } | null };

export type SubmitCartMutationVariables = Exact<{
  account_id: Scalars['String']['input'];
  store_id: Scalars['String']['input'];
  entity_id: Scalars['String']['input'];
}>;


export type SubmitCartMutation = { __typename?: 'Mutation', submitCart?: string | null };

export type UpdateTreezCartMutationVariables = Exact<{
  account_id: Scalars['String']['input'];
  store_id: Scalars['String']['input'];
  input: UpdateCartInput;
}>;


export type UpdateTreezCartMutation = { __typename?: 'Mutation', updateTreezCart?: { __typename?: 'UpdateTreezCartResponse', status: boolean, specials?: Array<{ __typename?: 'TreezSpecial', title: string, amount: number }> | null, order?: { __typename?: 'Order', entity_id?: string | null, key?: string | null, status?: OrderStatusType | null, email?: string | null, date_of_birth?: any | null, notes?: string | null, buyer_accepts_marketing?: boolean | null, jane_cart_id?: string | null, jane_order_id?: string | null, jane_store_id?: string | null, jane_store_name?: string | null, subtotal_price?: number | null, total_line_items_price?: number | null, total_discounts?: number | null, total_price?: number | null, total_tax?: number | null, total_delivery?: number | null, total_service_fee?: number | null, treez_order_id?: string | null, treez_order_number?: string | null, state_of_residence?: string | null, delivery_address?: { __typename?: 'OrderAddress', address1?: string | null, address2?: string | null, city?: string | null, country?: string | null, first_name?: string | null, last_name?: string | null, phone?: string | null, province?: string | null, zip?: string | null, province_code?: string | null, country_code?: string | null, city_code?: string | null, latitude?: number | null, longitude?: number | null } | null, discount_items?: Array<{ __typename?: 'OrderDiscountItem', id?: string | null, blaze_id?: string | null, discountType?: DiscountType | null, discount_rate_type?: DiscountRateType | null, discount_apply_type?: DiscountApplyType | null, promo_code?: string | null, rate?: number | null } | null> | null, line_items?: Array<{ __typename?: 'LineItem', item_id?: string | null, name?: string | null, quantity?: number | null, price?: number | null, sale_price?: number | null, weight?: number | null, length?: number | null, height?: number | null, width?: number | null, product_width?: number | null, product_height?: number | null, weight_unit?: string | null, length_unit?: DimensionUnitType | null, width_unit?: DimensionUnitType | null, height_unit?: DimensionUnitType | null, thumbnail?: string | null, barcodes?: Array<string | null> | null, brand?: string | null, category?: string | null, pos_id?: string | null, variants?: Array<{ __typename?: 'Variant', id?: string | null, name?: string | null, price?: number | null, type?: string | null } | null> | null } | null> | null, payment_details?: { __typename?: 'PaymentDetail', type?: PaymentType | null, treezpay_detail?: { __typename?: 'TreezPayPaymentDetail', payment_method?: string | null, processor_name: string } | null } | null, delivery_details?: { __typename?: 'OrderDelivery', deliver_after?: any | null, deliver_before?: any | null, delivery?: boolean | null, pickup?: boolean | null } | null, treez_pay_ticket_ids_by_store?: Array<{ __typename?: 'TreezPayTicket', provider_store_id: string, ticket_id: string, created_at?: any | null } | null> | null } | null, error?: { __typename?: 'ErrorResponse', code: ErrorResponseCodeType, message: string } | null } | null };

export type SubmitKioskCheckoutMutationVariables = Exact<{
  account_id: Scalars['String']['input'];
  store_id: Scalars['String']['input'];
  input: UpdateCartInput;
}>;


export type SubmitKioskCheckoutMutation = { __typename?: 'Mutation', submitKioskCheckout?: string | null };

export type CustomerCancelOrderMutationVariables = Exact<{
  account_id: Scalars['String']['input'];
  store_id: Scalars['String']['input'];
  entity_id: Scalars['String']['input'];
}>;


export type CustomerCancelOrderMutation = { __typename?: 'Mutation', customerCancelOrder?: { __typename?: 'Order', entity_id?: string | null, key?: string | null } | null };

export type GetStoreQueryVariables = Exact<{
  account_id: Scalars['String']['input'];
  store_id: Scalars['String']['input'];
}>;


export type GetStoreQuery = { __typename?: 'Query', getStore?: { __typename?: 'Store', name?: string | null, email?: string | null, logo?: string | null, logo_small?: string | null, instagram?: string | null, facebook?: string | null, twitter?: string | null, yelp?: string | null, youtube?: string | null, address1?: string | null, address2?: string | null, city?: string | null, country?: string | null, country_code?: string | null, country_name?: string | null, province?: string | null, province_code?: string | null, zip?: string | null, latitude?: number | null, longitude?: number | null, domain?: string | null, phone_number?: string | null, currency?: string | null, tax_active?: boolean | null, tax_type?: TaxType | null, tax_ammont?: number | null, min_order_amount?: number | null, gtm_active?: boolean | null, gtm_id?: string | null, timezone?: string | null, store_feature?: Array<{ __typename?: 'StoreFeature', id?: string | null, status?: boolean | null, name?: string | null, position?: number | null, description?: string | null } | null> | null, account_setting?: { __typename?: 'AccountSetting', active?: boolean | null, auto_verify_email?: boolean | null, cognito_identity_pool_id?: string | null, cognito_region?: string | null, user_pools_id?: string | null, user_pools_web_client_id?: string | null } | null, aws_pinpoint_analytics?: { __typename?: 'AwsPinpointAnalytics', active?: boolean | null, identity_pool_id?: string | null, auth_region?: string | null, app_id?: string | null, region?: string | null } | null } | null };


export const GetAccountByEmailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAccountByEmail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"account_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"store_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"provider_store"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProviderStore"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAccountByEmail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"account_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"account_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"store_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"store_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"provider_store"},"value":{"kind":"Variable","name":{"kind":"Name","value":"provider_store"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"photo"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"date_of_birth"}},{"kind":"Field","name":{"kind":"Name","value":"entity_id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"driver_license_id"}},{"kind":"Field","name":{"kind":"Name","value":"driver_license_photo"}},{"kind":"Field","name":{"kind":"Name","value":"driver_license_id_expiration_date"}},{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"province"}},{"kind":"Field","name":{"kind":"Name","value":"province_code"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"city_code"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"accept_marketing"}},{"kind":"Field","name":{"kind":"Name","value":"has_account"}},{"kind":"Field","name":{"kind":"Name","value":"checkin_from_dispensary"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"loyalty_points"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"alpineiq_verified"}},{"kind":"Field","name":{"kind":"Name","value":"alpineiq_contact_id"}},{"kind":"Field","name":{"kind":"Name","value":"loyalty_points_time_line"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"points"}},{"kind":"Field","name":{"kind":"Name","value":"note"}}]}},{"kind":"Field","name":{"kind":"Name","value":"treez_ids"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"store_id"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"medical_id"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"expiration_date"}}]}}]}}]}}]} as unknown as DocumentNode<GetAccountByEmailQuery, GetAccountByEmailQueryVariables>;
export const CustomerOrderHistoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"customerOrderHistory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"account_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"store_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"total_price"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerOrderHistory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"account_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"account_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"store_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"store_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"cursor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}},{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"total_price"},"value":{"kind":"Variable","name":{"kind":"Name","value":"total_price"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"orders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entity_id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"delivery_details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delivery"}},{"kind":"Field","name":{"kind":"Name","value":"pickup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"delivery_address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"province"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"line_items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"item_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"variants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"salePrice"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"order_number"}},{"kind":"Field","name":{"kind":"Name","value":"treez_order_number"}},{"kind":"Field","name":{"kind":"Name","value":"total_price"}}]}}]}}]}}]} as unknown as DocumentNode<CustomerOrderHistoryQuery, CustomerOrderHistoryQueryVariables>;
export const CreateAccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createAccount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"account_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"store_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateAccountInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAccount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"account_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"account_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"store_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"store_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]} as unknown as DocumentNode<CreateAccountMutation, CreateAccountMutationVariables>;
export const UpdateAccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateAccount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"account_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"store_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateAccountInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAccount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"account_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"account_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"store_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"store_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]} as unknown as DocumentNode<UpdateAccountMutation, UpdateAccountMutationVariables>;
export const UploadAccountPhotoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uploadAccountPhoto"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"account_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"store_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AccountUploadPhotoInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uploadAccountPhoto"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"account_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"account_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"store_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"store_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file_name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"headers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UploadAccountPhotoMutation, UploadAccountPhotoMutationVariables>;
export const GetAccountPhotoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAccountPhoto"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filename"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAccountPhoto"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filename"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filename"}}}]}]}}]} as unknown as DocumentNode<GetAccountPhotoQuery, GetAccountPhotoQueryVariables>;
export const CreateBerbixClientTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createBerbixClientToken"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"account_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"store_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BerbixClientTokenInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createBerbixClientToken"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"account_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"account_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"store_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"store_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"access_token"}},{"kind":"Field","name":{"kind":"Name","value":"client_token"}},{"kind":"Field","name":{"kind":"Name","value":"expires_at"}},{"kind":"Field","name":{"kind":"Name","value":"refresh_token"}}]}}]}}]} as unknown as DocumentNode<CreateBerbixClientTokenMutation, CreateBerbixClientTokenMutationVariables>;
export const GetBerbixTransactionResultDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getBerbixTransactionResult"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"account_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"store_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"access_token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"refresh_token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getBerbixTransactionResult"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"account_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"account_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"store_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"store_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"access_token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"access_token"}}},{"kind":"Argument","name":{"kind":"Name","value":"refresh_token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"refresh_token"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"valitated_user"}},{"kind":"Field","name":{"kind":"Name","value":"reason_not_validated"}}]}}]}}]} as unknown as DocumentNode<GetBerbixTransactionResultQuery, GetBerbixTransactionResultQueryVariables>;
export const IdScanVerificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"idScanVerification"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"account_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"store_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"IDScanValidationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idScanVerification"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"account_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"account_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"store_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"store_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}}]}}]} as unknown as DocumentNode<IdScanVerificationMutation, IdScanVerificationMutationVariables>;
export const SetTreezCustomerUnverifiedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"setTreezCustomerUnverified"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setTreezCustomerUnverified"}}]}}]} as unknown as DocumentNode<SetTreezCustomerUnverifiedMutation, SetTreezCustomerUnverifiedMutationVariables>;
export const GetOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"account_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"store_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"entity_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"account_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"account_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"store_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"store_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"entity_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"entity_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entity_id"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"delivery_details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pickup"}},{"kind":"Field","name":{"kind":"Name","value":"delivery"}},{"kind":"Field","name":{"kind":"Name","value":"started_at"}},{"kind":"Field","name":{"kind":"Name","value":"finished_at"}}]}},{"kind":"Field","name":{"kind":"Name","value":"delivery_address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"province"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}},{"kind":"Field","name":{"kind":"Name","value":"line_items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"item_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"in_stock"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"}},{"kind":"Field","name":{"kind":"Name","value":"variants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"salePrice"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"payment_details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"card_type"}},{"kind":"Field","name":{"kind":"Name","value":"last_four"}},{"kind":"Field","name":{"kind":"Name","value":"refunded"}},{"kind":"Field","name":{"kind":"Name","value":"refund_id"}},{"kind":"Field","name":{"kind":"Name","value":"treezpay_detail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"payment_method"}},{"kind":"Field","name":{"kind":"Name","value":"processor_name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"order_number"}},{"kind":"Field","name":{"kind":"Name","value":"treez_order_number"}},{"kind":"Field","name":{"kind":"Name","value":"treez_pay_ticket_ids_by_store"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"provider_store_id"}},{"kind":"Field","name":{"kind":"Name","value":"ticket_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}},{"kind":"Field","name":{"kind":"Name","value":"state_of_residence"}},{"kind":"Field","name":{"kind":"Name","value":"subtotal_price"}},{"kind":"Field","name":{"kind":"Name","value":"total_discounts"}},{"kind":"Field","name":{"kind":"Name","value":"total_line_items_price"}},{"kind":"Field","name":{"kind":"Name","value":"total_price"}},{"kind":"Field","name":{"kind":"Name","value":"total_tax"}},{"kind":"Field","name":{"kind":"Name","value":"total_delivery"}},{"kind":"Field","name":{"kind":"Name","value":"total_service_fee"}}]}}]}}]} as unknown as DocumentNode<GetOrderQuery, GetOrderQueryVariables>;
export const UpdateCartDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateCart"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"account_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"store_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"updateCartInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateJaneCart"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"account_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"account_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"store_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"store_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entity_id"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"discount_items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"blaze_id"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}},{"kind":"Field","name":{"kind":"Name","value":"discount_rate_type"}},{"kind":"Field","name":{"kind":"Name","value":"discount_apply_type"}},{"kind":"Field","name":{"kind":"Name","value":"promo_code"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"line_items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"item_id"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"}},{"kind":"Field","name":{"kind":"Name","value":"variants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"subtotal_price"}},{"kind":"Field","name":{"kind":"Name","value":"total_line_items_price"}},{"kind":"Field","name":{"kind":"Name","value":"total_discounts"}},{"kind":"Field","name":{"kind":"Name","value":"total_price"}},{"kind":"Field","name":{"kind":"Name","value":"total_tax"}},{"kind":"Field","name":{"kind":"Name","value":"total_delivery"}},{"kind":"Field","name":{"kind":"Name","value":"total_service_fee"}},{"kind":"Field","name":{"kind":"Name","value":"jane_store_full_address"}},{"kind":"Field","name":{"kind":"Name","value":"jane_store_phone_number"}}]}}]}}]} as unknown as DocumentNode<UpdateCartMutation, UpdateCartMutationVariables>;
export const SubmitCartDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"submitCart"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"account_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"store_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"entity_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"submitCart"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"account_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"account_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"store_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"store_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"entity_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"entity_id"}}}]}]}}]} as unknown as DocumentNode<SubmitCartMutation, SubmitCartMutationVariables>;
export const UpdateTreezCartDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateTreezCart"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"account_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"store_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"updateCartInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateTreezCart"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"account_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"account_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"store_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"store_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"specials"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entity_id"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"date_of_birth"}},{"kind":"Field","name":{"kind":"Name","value":"delivery_address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"province"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"province_code"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"city_code"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discount_items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"blaze_id"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}},{"kind":"Field","name":{"kind":"Name","value":"discount_rate_type"}},{"kind":"Field","name":{"kind":"Name","value":"discount_apply_type"}},{"kind":"Field","name":{"kind":"Name","value":"promo_code"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"line_items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"item_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"length"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"product_width"}},{"kind":"Field","name":{"kind":"Name","value":"product_height"}},{"kind":"Field","name":{"kind":"Name","value":"weight_unit"}},{"kind":"Field","name":{"kind":"Name","value":"length_unit"}},{"kind":"Field","name":{"kind":"Name","value":"width_unit"}},{"kind":"Field","name":{"kind":"Name","value":"height_unit"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"}},{"kind":"Field","name":{"kind":"Name","value":"variants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"barcodes"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"pos_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_accepts_marketing"}},{"kind":"Field","name":{"kind":"Name","value":"payment_details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"treezpay_detail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"payment_method"}},{"kind":"Field","name":{"kind":"Name","value":"processor_name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"delivery_details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deliver_after"}},{"kind":"Field","name":{"kind":"Name","value":"deliver_before"}},{"kind":"Field","name":{"kind":"Name","value":"delivery"}},{"kind":"Field","name":{"kind":"Name","value":"pickup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"jane_cart_id"}},{"kind":"Field","name":{"kind":"Name","value":"jane_order_id"}},{"kind":"Field","name":{"kind":"Name","value":"jane_store_id"}},{"kind":"Field","name":{"kind":"Name","value":"jane_store_name"}},{"kind":"Field","name":{"kind":"Name","value":"subtotal_price"}},{"kind":"Field","name":{"kind":"Name","value":"total_line_items_price"}},{"kind":"Field","name":{"kind":"Name","value":"total_discounts"}},{"kind":"Field","name":{"kind":"Name","value":"total_price"}},{"kind":"Field","name":{"kind":"Name","value":"total_tax"}},{"kind":"Field","name":{"kind":"Name","value":"total_delivery"}},{"kind":"Field","name":{"kind":"Name","value":"total_service_fee"}},{"kind":"Field","name":{"kind":"Name","value":"treez_order_id"}},{"kind":"Field","name":{"kind":"Name","value":"treez_order_number"}},{"kind":"Field","name":{"kind":"Name","value":"treez_pay_ticket_ids_by_store"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"provider_store_id"}},{"kind":"Field","name":{"kind":"Name","value":"ticket_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}},{"kind":"Field","name":{"kind":"Name","value":"state_of_residence"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateTreezCartMutation, UpdateTreezCartMutationVariables>;
export const SubmitKioskCheckoutDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"submitKioskCheckout"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"account_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"store_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"updateCartInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"submitKioskCheckout"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"account_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"account_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"store_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"store_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<SubmitKioskCheckoutMutation, SubmitKioskCheckoutMutationVariables>;
export const CustomerCancelOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"customerCancelOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"account_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"store_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"entity_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerCancelOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"account_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"account_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"store_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"store_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"entity_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"entity_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entity_id"}},{"kind":"Field","name":{"kind":"Name","value":"key"}}]}}]}}]} as unknown as DocumentNode<CustomerCancelOrderMutation, CustomerCancelOrderMutationVariables>;
export const GetStoreDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getStore"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"account_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"store_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getStore"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"account_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"account_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"store_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"store_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"logo_small"}},{"kind":"Field","name":{"kind":"Name","value":"instagram"}},{"kind":"Field","name":{"kind":"Name","value":"facebook"}},{"kind":"Field","name":{"kind":"Name","value":"twitter"}},{"kind":"Field","name":{"kind":"Name","value":"yelp"}},{"kind":"Field","name":{"kind":"Name","value":"youtube"}},{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"country_name"}},{"kind":"Field","name":{"kind":"Name","value":"province"}},{"kind":"Field","name":{"kind":"Name","value":"province_code"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"domain"}},{"kind":"Field","name":{"kind":"Name","value":"phone_number"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"tax_active"}},{"kind":"Field","name":{"kind":"Name","value":"tax_type"}},{"kind":"Field","name":{"kind":"Name","value":"tax_ammont"}},{"kind":"Field","name":{"kind":"Name","value":"min_order_amount"}},{"kind":"Field","name":{"kind":"Name","value":"gtm_active"}},{"kind":"Field","name":{"kind":"Name","value":"gtm_id"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"store_feature"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"account_setting"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"auto_verify_email"}},{"kind":"Field","name":{"kind":"Name","value":"cognito_identity_pool_id"}},{"kind":"Field","name":{"kind":"Name","value":"cognito_region"}},{"kind":"Field","name":{"kind":"Name","value":"user_pools_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_pools_web_client_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"aws_pinpoint_analytics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"identity_pool_id"}},{"kind":"Field","name":{"kind":"Name","value":"auth_region"}},{"kind":"Field","name":{"kind":"Name","value":"app_id"}},{"kind":"Field","name":{"kind":"Name","value":"region"}}]}}]}}]}}]} as unknown as DocumentNode<GetStoreQuery, GetStoreQueryVariables>;